(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global,setImmediate){
/*! @vimeo/player v2.15.0 | (c) 2021 Vimeo | MIT License | https://github.com/vimeo/player.js */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory()));
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  /**
   * @module lib/functions
   */

  /**
   * Check to see this is a node environment.
   * @type {Boolean}
   */

  /* global global */
  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';
  /**
   * Get the name of the method for a given getter or setter.
   *
   * @param {string} prop The name of the property.
   * @param {string} type Either “get” or “set”.
   * @return {string}
   */

  function getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) {
      return prop;
    }

    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
  }
  /**
   * Check to see if the object is a DOM Element.
   *
   * @param {*} element The object to check.
   * @return {boolean}
   */

  function isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
  }
  /**
   * Check to see whether the value is a number.
   *
   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
   * @param {*} value The value to check.
   * @param {boolean} integer Check if the value is an integer.
   * @return {boolean}
   */

  function isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
  }
  /**
   * Check to see if the URL is a Vimeo url.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */

  function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
  }
  /**
   * Get the Vimeo URL from an element.
   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
   *
   * @param {object} oEmbedParameters The oEmbed parameters.
   * @return {string}
   */

  function getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;

    if (!idOrUrl) {
      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    }

    if (isInteger(idOrUrl)) {
      return "https://vimeo.com/".concat(idOrUrl);
    }

    if (isVimeoUrl(idOrUrl)) {
      return idOrUrl.replace('http:', 'https:');
    }

    if (id) {
      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    }

    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
  }

  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';

  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /*!
   * weakmap-polyfill v2.0.1 - ECMAScript6 WeakMap polyfill
   * https://github.com/polygonplanet/weakmap-polyfill
   * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
   * @license MIT
   */
  (function (self) {

    if (self.WeakMap) {
      return;
    }

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    var defineProperty = function (object, name, value) {
      if (Object.defineProperty) {
        Object.defineProperty(object, name, {
          configurable: true,
          writable: true,
          value: value
        });
      } else {
        object[name] = value;
      }
    };

    self.WeakMap = function () {
      // ECMA-262 23.3 WeakMap Objects
      function WeakMap() {
        if (this === void 0) {
          throw new TypeError("Constructor WeakMap requires 'new'");
        }

        defineProperty(this, '_id', genId('_WeakMap')); // ECMA-262 23.3.1.1 WeakMap([iterable])

        if (arguments.length > 0) {
          // Currently, WeakMap `iterable` argument is not supported
          throw new TypeError('WeakMap iterable is not supported');
        }
      } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)


      defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          delete key[this._id];
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)

      defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');

        if (!isObject(key)) {
          return void 0;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return entry[1];
        }

        return void 0;
      }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)

      defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');

        if (!isObject(key)) {
          return false;
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          return true;
        }

        return false;
      }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)

      defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');

        if (!isObject(key)) {
          throw new TypeError('Invalid value used as weak map key');
        }

        var entry = key[this._id];

        if (entry && entry[0] === key) {
          entry[1] = value;
          return this;
        }

        defineProperty(key, this._id, [key, value]);
        return this;
      });

      function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
      }

      function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
      }

      function rand() {
        return Math.random().toString().substring(2);
      }

      defineProperty(WeakMap, '_polyfill', true);
      return WeakMap;
    }();

    function isObject(x) {
      return Object(x) === x;
    }
  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

  var npo_src = createCommonjsModule(function (module) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function UMD(name, context, definition) {
    // special form of UMD for polyfilling across evironments
    context[name] = context[name] || definition();

    if ( module.exports) {
      module.exports = context[name];
    }
  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

    var builtInProp,
        cycle,
        scheduling_queue,
        ToString = Object.prototype.toString,
        timer = typeof setImmediate != "undefined" ? function timer(fn) {
      return setImmediate(fn);
    } : setTimeout; // dammit, IE8.

    try {
      Object.defineProperty({}, "x", {});

      builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
          value: val,
          writable: true,
          configurable: config !== false
        });
      };
    } catch (err) {
      builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
      };
    } // Note: using a queue instead of array for efficiency


    scheduling_queue = function Queue() {
      var first, last, item;

      function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
      }

      return {
        add: function add(fn, self) {
          item = new Item(fn, self);

          if (last) {
            last.next = item;
          } else {
            first = item;
          }

          last = item;
          item = void 0;
        },
        drain: function drain() {
          var f = first;
          first = last = cycle = void 0;

          while (f) {
            f.fn.call(f.self);
            f = f.next;
          }
        }
      };
    }();

    function schedule(fn, self) {
      scheduling_queue.add(fn, self);

      if (!cycle) {
        cycle = timer(scheduling_queue.drain);
      }
    } // promise duck typing


    function isThenable(o) {
      var _then,
          o_type = typeof o;

      if (o != null && (o_type == "object" || o_type == "function")) {
        _then = o.then;
      }

      return typeof _then == "function" ? _then : false;
    }

    function notify() {
      for (var i = 0; i < this.chain.length; i++) {
        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
      }

      this.chain.length = 0;
    } // NOTE: This is a separate function to isolate
    // the `try..catch` so that other code can be
    // optimized better


    function notifyIsolated(self, cb, chain) {
      var ret, _then;

      try {
        if (cb === false) {
          chain.reject(self.msg);
        } else {
          if (cb === true) {
            ret = self.msg;
          } else {
            ret = cb.call(void 0, self.msg);
          }

          if (ret === chain.promise) {
            chain.reject(TypeError("Promise-chain cycle"));
          } else if (_then = isThenable(ret)) {
            _then.call(ret, chain.resolve, chain.reject);
          } else {
            chain.resolve(ret);
          }
        }
      } catch (err) {
        chain.reject(err);
      }
    }

    function resolve(msg) {
      var _then,
          self = this; // already triggered?


      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      try {
        if (_then = isThenable(msg)) {
          schedule(function () {
            var def_wrapper = new MakeDefWrapper(self);

            try {
              _then.call(msg, function $resolve$() {
                resolve.apply(def_wrapper, arguments);
              }, function $reject$() {
                reject.apply(def_wrapper, arguments);
              });
            } catch (err) {
              reject.call(def_wrapper, err);
            }
          });
        } else {
          self.msg = msg;
          self.state = 1;

          if (self.chain.length > 0) {
            schedule(notify, self);
          }
        }
      } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
      }
    }

    function reject(msg) {
      var self = this; // already triggered?

      if (self.triggered) {
        return;
      }

      self.triggered = true; // unwrap

      if (self.def) {
        self = self.def;
      }

      self.msg = msg;
      self.state = 2;

      if (self.chain.length > 0) {
        schedule(notify, self);
      }
    }

    function iteratePromises(Constructor, arr, resolver, rejecter) {
      for (var idx = 0; idx < arr.length; idx++) {
        (function IIFE(idx) {
          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
          }, rejecter);
        })(idx);
      }
    }

    function MakeDefWrapper(self) {
      this.def = self;
      this.triggered = false;
    }

    function MakeDef(self) {
      this.promise = self;
      this.state = 0;
      this.triggered = false;
      this.chain = [];
      this.msg = void 0;
    }

    function Promise(executor) {
      if (typeof executor != "function") {
        throw TypeError("Not a function");
      }

      if (this.__NPO__ !== 0) {
        throw TypeError("Not a promise");
      } // instance shadowing the inherited "brand"
      // to signal an already "initialized" promise


      this.__NPO__ = 1;
      var def = new MakeDef(this);

      this["then"] = function then(success, failure) {
        var o = {
          success: typeof success == "function" ? success : true,
          failure: typeof failure == "function" ? failure : false
        }; // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.

        o.promise = new this.constructor(function extractChain(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }

          o.resolve = resolve;
          o.reject = reject;
        });
        def.chain.push(o);

        if (def.state !== 0) {
          schedule(notify, def);
        }

        return o.promise;
      };

      this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
      };

      try {
        executor.call(void 0, function publicResolve(msg) {
          resolve.call(def, msg);
        }, function publicReject(msg) {
          reject.call(def, msg);
        });
      } catch (err) {
        reject.call(def, err);
      }
    }

    var PromisePrototype = builtInProp({}, "constructor", Promise,
    /*configurable=*/
    false); // Note: Android 4 cannot use `Object.defineProperty(..)` here

    Promise.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise

    builtInProp(PromisePrototype, "__NPO__", 0,
    /*configurable=*/
    false);
    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
      var Constructor = this; // spec mandated checks
      // note: best "isPromise" check that's practical for now

      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
        return msg;
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        resolve(msg);
      });
    });
    builtInProp(Promise, "reject", function Promise$reject(msg) {
      return new this(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        reject(msg);
      });
    });
    builtInProp(Promise, "all", function Promise$all(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      if (arr.length === 0) {
        return Constructor.resolve([]);
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        var len = arr.length,
            msgs = Array(len),
            count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          msgs[idx] = msg;

          if (++count === len) {
            resolve(msgs);
          }
        }, reject);
      });
    });
    builtInProp(Promise, "race", function Promise$race(arr) {
      var Constructor = this; // spec mandated checks

      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }

      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }

        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          resolve(msg);
        }, reject);
      });
    });
    return Promise;
  });
  });

  /**
   * @module lib/callbacks
   */
  var callbackMap = new WeakMap();
  /**
   * Store a callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
   *        The callback to call or an object with resolve and reject functions for a promise.
   * @return {void}
   */

  function storeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!(name in playerCallbacks)) {
      playerCallbacks[name] = [];
    }

    playerCallbacks[name].push(callback);
    callbackMap.set(player.element, playerCallbacks);
  }
  /**
   * Get the callbacks for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @return {function[]}
   */

  function getCallbacks(player, name) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
  }
  /**
   * Remove a stored callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @param {function} [callback] The specific callback to remove.
   * @return {boolean} Was this the last callback?
   */

  function removeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};

    if (!playerCallbacks[name]) {
      return true;
    } // If no callback is passed, remove all callbacks for the event


    if (!callback) {
      playerCallbacks[name] = [];
      callbackMap.set(player.element, playerCallbacks);
      return true;
    }

    var index = playerCallbacks[name].indexOf(callback);

    if (index !== -1) {
      playerCallbacks[name].splice(index, 1);
    }

    callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
  }
  /**
   * Return the first stored callback for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @return {function} The callback, or false if there were none
   */

  function shiftCallbacks(player, name) {
    var playerCallbacks = getCallbacks(player, name);

    if (playerCallbacks.length < 1) {
      return false;
    }

    var callback = playerCallbacks.shift();
    removeCallback(player, name, callback);
    return callback;
  }
  /**
   * Move callbacks associated with an element to another element.
   *
   * @param {HTMLElement} oldElement The old element.
   * @param {HTMLElement} newElement The new element.
   * @return {void}
   */

  function swapCallbacks(oldElement, newElement) {
    var playerCallbacks = callbackMap.get(oldElement);
    callbackMap.set(newElement, playerCallbacks);
    callbackMap.delete(oldElement);
  }

  /**
   * @module lib/embed
   */
  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'controls', 'dnt', 'height', 'id', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];
  /**
   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
   *
   * @param {HTMLElement} element The element.
   * @param {Object} [defaults={}] The default values to use.
   * @return {Object<string, string>}
   */

  function getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return oEmbedParameters.reduce(function (params, param) {
      var value = element.getAttribute("data-vimeo-".concat(param));

      if (value || value === '') {
        params[param] = value === '' ? 1 : value;
      }

      return params;
    }, defaults);
  }
  /**
   * Create an embed from oEmbed data inside an element.
   *
   * @param {object} data The oEmbed data.
   * @param {HTMLElement} element The element to put the iframe in.
   * @return {HTMLIFrameElement} The iframe embed.
   */

  function createEmbed(_ref, element) {
    var html = _ref.html;

    if (!element) {
      throw new TypeError('An element must be provided');
    }

    if (element.getAttribute('data-vimeo-initialized') !== null) {
      return element.querySelector('iframe');
    }

    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
  }
  /**
   * Make an oEmbed call for the specified URL.
   *
   * @param {string} videoUrl The vimeo.com url for the video.
   * @param {Object} [params] Parameters to pass to oEmbed.
   * @param {HTMLElement} element The element.
   * @return {Promise}
   */

  function getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      if (!isVimeoUrl(videoUrl)) {
        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
      }

      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));

      for (var param in params) {
        if (params.hasOwnProperty(param)) {
          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        }
      }

      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
      xhr.open('GET', url, true);

      xhr.onload = function () {
        if (xhr.status === 404) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
          return;
        }

        if (xhr.status === 403) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }

        try {
          var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed

          if (json.domain_status_code === 403) {
            // We still want to create the embed to give users visual feedback
            createEmbed(json, element);
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }

          resolve(json);
        } catch (error) {
          reject(error);
        }
      };

      xhr.onerror = function () {
        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
      };

      xhr.send();
    });
  }
  /**
   * Initialize all embeds within a specific element
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));

    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error creating an embed: ".concat(error));
      }
    };

    elements.forEach(function (element) {
      try {
        // Skip any that have data-vimeo-defer
        if (element.getAttribute('data-vimeo-defer') !== null) {
          return;
        }

        var params = getOEmbedParameters(element);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          return createEmbed(data, element);
        }).catch(handleError);
      } catch (error) {
        handleError(error);
      }
    });
  }
  /**
   * Resize embeds when messaged by the player.
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */

  function resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) {
      return;
    }

    window.VimeoPlayerResizeEmbeds_ = true;

    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      } // 'spacechange' is fired only on embeds with cards


      if (!event.data || event.data.event !== 'spacechange') {
        return;
      }

      var iframes = parent.querySelectorAll('iframe');

      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow !== event.source) {
          continue;
        } // Change padding-bottom of the enclosing div to accommodate
        // card carousel without distorting aspect ratio


        var space = iframes[i].parentElement;
        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        break;
      }
    };

    window.addEventListener('message', onMessage);
  }

  /**
   * @module lib/postmessage
   */
  /**
   * Parse a message received from postMessage.
   *
   * @param {*} data The data received from postMessage.
   * @return {object}
   */

  function parseMessageData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
      }
    }

    return data;
  }
  /**
   * Post a message to the specified target.
   *
   * @param {Player} player The player object to use.
   * @param {string} method The API method to call.
   * @param {object} params The parameters to send to the player.
   * @return {void}
   */

  function postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
      return;
    }

    var message = {
      method: method
    };

    if (params !== undefined) {
      message.value = params;
    } // IE 8 and 9 do not support passing messages, so stringify them


    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));

    if (ieVersion >= 8 && ieVersion < 10) {
      message = JSON.stringify(message);
    }

    player.element.contentWindow.postMessage(message, player.origin);
  }
  /**
   * Parse the data received from a message event.
   *
   * @param {Player} player The player that received the message.
   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
   * @return {void}
   */

  function processData(player, data) {
    data = parseMessageData(data);
    var callbacks = [];
    var param;

    if (data.event) {
      if (data.event === 'error') {
        var promises = getCallbacks(player, data.data.method);
        promises.forEach(function (promise) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          promise.reject(error);
          removeCallback(player, data.data.method, promise);
        });
      }

      callbacks = getCallbacks(player, "event:".concat(data.event));
      param = data.data;
    } else if (data.method) {
      var callback = shiftCallbacks(player, data.method);

      if (callback) {
        callbacks.push(callback);
        param = data.value;
      }
    }

    callbacks.forEach(function (callback) {
      try {
        if (typeof callback === 'function') {
          callback.call(player, param);
          return;
        }

        callback.resolve(param);
      } catch (e) {// empty
      }
    });
  }

  /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */
  function initializeScreenfull() {
    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};

      for (; i < l; i++) {
        val = fnMap[i];

        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }

          return ret;
        }
      }

      return false;
    }();

    var eventNameMap = {
      fullscreenchange: fn.fullscreenchange,
      fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(element) {
        return new Promise(function (resolve, reject) {
          var onFullScreenEntered = function onFullScreenEntered() {
            screenfull.off('fullscreenchange', onFullScreenEntered);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenEntered);
          element = element || document.documentElement;
          var returnPromise = element[fn.requestFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        });
      },
      exit: function exit() {
        return new Promise(function (resolve, reject) {
          if (!screenfull.isFullscreen) {
            resolve();
            return;
          }

          var onFullScreenExit = function onFullScreenExit() {
            screenfull.off('fullscreenchange', onFullScreenExit);
            resolve();
          };

          screenfull.on('fullscreenchange', onFullScreenExit);
          var returnPromise = document[fn.exitFullscreen]();

          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        });
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.addEventListener(eventName, callback);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.removeEventListener(eventName, callback);
        }
      }
    };
    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });
    return screenfull;
  }

  var playerMap = new WeakMap();
  var readyMap = new WeakMap();
  var screenfull = {};

  var Player = /*#__PURE__*/function () {
    /**
     * Create a Player.
     *
     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
     *        player iframe, and id, or a jQuery object.
     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
     * @return {Player}
     */
    function Player(element) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Player);

      /* global jQuery */
      if (window.jQuery && element instanceof jQuery) {
        if (element.length > 1 && window.console && console.warn) {
          console.warn('A jQuery object with multiple elements was passed, using the first element.');
        }

        element = element[0];
      } // Find an element by ID


      if (typeof document !== 'undefined' && typeof element === 'string') {
        element = document.getElementById(element);
      } // Not an element!


      if (!isDomElement(element)) {
        throw new TypeError('You must pass either a valid element or a valid id.');
      } // Already initialized an embed in this div, so grab the iframe


      if (element.nodeName !== 'IFRAME') {
        var iframe = element.querySelector('iframe');

        if (iframe) {
          element = iframe;
        }
      } // iframe url is not a Vimeo url


      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
        throw new Error('The player element passed isn’t a Vimeo embed.');
      } // If there is already a player object in the map, return that


      if (playerMap.has(element)) {
        return playerMap.get(element);
      }

      this._window = element.ownerDocument.defaultView;
      this.element = element;
      this.origin = '*';
      var readyPromise = new npo_src(function (resolve, reject) {
        _this._onMessage = function (event) {
          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
            return;
          }

          if (_this.origin === '*') {
            _this.origin = event.origin;
          }

          var data = parseMessageData(event.data);
          var isError = data && data.event === 'error';
          var isReadyError = isError && data.data && data.data.method === 'ready';

          if (isReadyError) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            reject(error);
            return;
          }

          var isReadyEvent = data && data.event === 'ready';
          var isPingResponse = data && data.method === 'ping';

          if (isReadyEvent || isPingResponse) {
            _this.element.setAttribute('data-ready', 'true');

            resolve();
            return;
          }

          processData(_this, data);
        };

        _this._window.addEventListener('message', _this._onMessage);

        if (_this.element.nodeName !== 'IFRAME') {
          var params = getOEmbedParameters(element, options);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            var iframe = createEmbed(data, element); // Overwrite element with the new iframe,
            // but store reference to the original element

            _this.element = iframe;
            _this._originalElement = element;
            swapCallbacks(element, iframe);
            playerMap.set(_this.element, _this);
            return data;
          }).catch(reject);
        }
      }); // Store a copy of this Player in the map

      readyMap.set(this, readyPromise);
      playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
      // the player is already ready.

      if (this.element.nodeName === 'IFRAME') {
        postMessage(this, 'ping');
      }

      if (screenfull.isEnabled) {
        var exitFullscreen = function exitFullscreen() {
          return screenfull.exit();
        };

        screenfull.on('fullscreenchange', function () {
          if (screenfull.isFullscreen) {
            storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } else {
            removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } // eslint-disable-next-line


          _this.ready().then(function () {
            postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
          });
        });
      }

      return this;
    }
    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {Object} [args={}] Arguments to send via postMessage.
     * @return {Promise}
     */


    _createClass(Player, [{
      key: "callMethod",
      value: function callMethod(name) {
        var _this2 = this;

        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new npo_src(function (resolve, reject) {
          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this2.ready().then(function () {
            storeCallback(_this2, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this2, name, args);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for the value of a player property.
       *
       * @param {string} name The property name
       * @return {Promise}
       */

    }, {
      key: "get",
      value: function get(name) {
        var _this3 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'get'); // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return

          return _this3.ready().then(function () {
            storeCallback(_this3, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this3, name);
          }).catch(reject);
        });
      }
      /**
       * Get a promise for setting the value of a player property.
       *
       * @param {string} name The API method to call.
       * @param {mixed} value The value to set.
       * @return {Promise}
       */

    }, {
      key: "set",
      value: function set(name, value) {
        var _this4 = this;

        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'set');

          if (value === undefined || value === null) {
            throw new TypeError('There must be a value to set.');
          } // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return


          return _this4.ready().then(function () {
            storeCallback(_this4, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this4, name, value);
          }).catch(reject);
        });
      }
      /**
       * Add an event listener for the specified event. Will call the
       * callback with a single parameter, `data`, that contains the data for
       * that event.
       *
       * @param {string} eventName The name of the event.
       * @param {function(*)} callback The function to call when the event fires.
       * @return {void}
       */

    }, {
      key: "on",
      value: function on(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (!callback) {
          throw new TypeError('You must pass a callback function.');
        }

        if (typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var callbacks = getCallbacks(this, "event:".concat(eventName));

        if (callbacks.length === 0) {
          this.callMethod('addEventListener', eventName).catch(function () {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }

        storeCallback(this, "event:".concat(eventName), callback);
      }
      /**
       * Remove an event listener for the specified event. Will remove all
       * listeners for that event if a `callback` isn’t passed, or only that
       * specific callback if it is passed.
       *
       * @param {string} eventName The name of the event.
       * @param {function} [callback] The specific callback to remove.
       * @return {void}
       */

    }, {
      key: "off",
      value: function off(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }

        if (callback && typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }

        var lastCallback = removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener

        if (lastCallback) {
          this.callMethod('removeEventListener', eventName).catch(function (e) {// Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
      }
      /**
       * A promise to load a new video.
       *
       * @promise LoadVideoPromise
       * @fulfill {number} The video with this id successfully loaded.
       * @reject {TypeError} The id was not a number.
       */

      /**
       * Load a new video into this embed. The promise will be resolved if
       * the video is successfully loaded, or it will be rejected if it could
       * not be loaded.
       *
       * @param {number|object} options The id of the video or an object with embed options.
       * @return {LoadVideoPromise}
       */

    }, {
      key: "loadVideo",
      value: function loadVideo(options) {
        return this.callMethod('loadVideo', options);
      }
      /**
       * A promise to perform an action when the Player is ready.
       *
       * @todo document errors
       * @promise LoadVideoPromise
       * @fulfill {void}
       */

      /**
       * Trigger a function when the player iframe has initialized. You do not
       * need to wait for `ready` to trigger to begin adding event listeners
       * or calling other methods.
       *
       * @return {ReadyPromise}
       */

    }, {
      key: "ready",
      value: function ready() {
        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
          reject(new Error('Unknown player. Probably unloaded.'));
        });
        return npo_src.resolve(readyPromise);
      }
      /**
       * A promise to add a cue point to the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point to use for removeCuePoint.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Add a cue point to the player.
       *
       * @param {number} time The time for the cue point.
       * @param {object} [data] Arbitrary data to be returned with the cue point.
       * @return {AddCuePointPromise}
       */

    }, {
      key: "addCuePoint",
      value: function addCuePoint(time) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
          time: time,
          data: data
        });
      }
      /**
       * A promise to remove a cue point from the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point that was removed.
       * @reject {InvalidCuePoint} The cue point with the specified id was not
       *         found.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Remove a cue point from the video.
       *
       * @param {string} id The id of the cue point to remove.
       * @return {RemoveCuePointPromise}
       */

    }, {
      key: "removeCuePoint",
      value: function removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
      }
      /**
       * A representation of a text track on a video.
       *
       * @typedef {Object} VimeoTextTrack
       * @property {string} language The ISO language code.
       * @property {string} kind The kind of track it is (captions or subtitles).
       * @property {string} label The human‐readable label for the track.
       */

      /**
       * A promise to enable a text track.
       *
       * @promise EnableTextTrackPromise
       * @fulfill {VimeoTextTrack} The text track that was enabled.
       * @reject {InvalidTrackLanguageError} No track was available with the
       *         specified language.
       * @reject {InvalidTrackError} No track was available with the specified
       *         language and kind.
       */

      /**
       * Enable the text track with the specified language, and optionally the
       * specified kind (captions or subtitles).
       *
       * When set via the API, the track language will not change the viewer’s
       * stored preference.
       *
       * @param {string} language The two‐letter language code.
       * @param {string} [kind] The kind of track to enable (captions or subtitles).
       * @return {EnableTextTrackPromise}
       */

    }, {
      key: "enableTextTrack",
      value: function enableTextTrack(language, kind) {
        if (!language) {
          throw new TypeError('You must pass a language.');
        }

        return this.callMethod('enableTextTrack', {
          language: language,
          kind: kind
        });
      }
      /**
       * A promise to disable the active text track.
       *
       * @promise DisableTextTrackPromise
       * @fulfill {void} The track was disabled.
       */

      /**
       * Disable the currently-active text track.
       *
       * @return {DisableTextTrackPromise}
       */

    }, {
      key: "disableTextTrack",
      value: function disableTextTrack() {
        return this.callMethod('disableTextTrack');
      }
      /**
       * A promise to pause the video.
       *
       * @promise PausePromise
       * @fulfill {void} The video was paused.
       */

      /**
       * Pause the video if it’s playing.
       *
       * @return {PausePromise}
       */

    }, {
      key: "pause",
      value: function pause() {
        return this.callMethod('pause');
      }
      /**
       * A promise to play the video.
       *
       * @promise PlayPromise
       * @fulfill {void} The video was played.
       */

      /**
       * Play the video if it’s paused. **Note:** on iOS and some other
       * mobile devices, you cannot programmatically trigger play. Once the
       * viewer has tapped on the play button in the player, however, you
       * will be able to use this function.
       *
       * @return {PlayPromise}
       */

    }, {
      key: "play",
      value: function play() {
        return this.callMethod('play');
      }
      /**
       * Request that the player enters fullscreen.
       * @return {Promise}
       */

    }, {
      key: "requestFullscreen",
      value: function requestFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.request(this.element);
        }

        return this.callMethod('requestFullscreen');
      }
      /**
       * Request that the player exits fullscreen.
       * @return {Promise}
       */

    }, {
      key: "exitFullscreen",
      value: function exitFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.exit();
        }

        return this.callMethod('exitFullscreen');
      }
      /**
       * Returns true if the player is currently fullscreen.
       * @return {Promise}
       */

    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        if (screenfull.isEnabled) {
          return npo_src.resolve(screenfull.isFullscreen);
        }

        return this.get('fullscreen');
      }
      /**
       * Request that the player enters picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "requestPictureInPicture",
      value: function requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
      }
      /**
       * Request that the player exits picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "exitPictureInPicture",
      value: function exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
      }
      /**
       * Returns true if the player is currently picture-in-picture.
       * @return {Promise}
       */

    }, {
      key: "getPictureInPicture",
      value: function getPictureInPicture() {
        return this.get('pictureInPicture');
      }
      /**
       * A promise to unload the video.
       *
       * @promise UnloadPromise
       * @fulfill {void} The video was unloaded.
       */

      /**
       * Return the player to its initial state.
       *
       * @return {UnloadPromise}
       */

    }, {
      key: "unload",
      value: function unload() {
        return this.callMethod('unload');
      }
      /**
       * Cleanup the player and remove it from the DOM
       *
       * It won't be usable and a new one should be constructed
       *  in order to do any operations.
       *
       * @return {Promise}
       */

    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;

        return new npo_src(function (resolve) {
          readyMap.delete(_this5);
          playerMap.delete(_this5.element);

          if (_this5._originalElement) {
            playerMap.delete(_this5._originalElement);

            _this5._originalElement.removeAttribute('data-vimeo-initialized');
          }

          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
            _this5.element.parentNode.removeChild(_this5.element);
          } // If the clip is private there is a case where the element stays the
          // div element. Destroy should reset the div and remove the iframe child.


          if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
            _this5.element.removeAttribute('data-vimeo-initialized');

            var iframe = _this5.element.querySelector('iframe');

            if (iframe && iframe.parentNode) {
              iframe.parentNode.removeChild(iframe);
            }
          }

          _this5._window.removeEventListener('message', _this5._onMessage);

          resolve();
        });
      }
      /**
       * A promise to get the autopause behavior of the video.
       *
       * @promise GetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Get the autopause behavior for this player.
       *
       * @return {GetAutopausePromise}
       */

    }, {
      key: "getAutopause",
      value: function getAutopause() {
        return this.get('autopause');
      }
      /**
       * A promise to set the autopause behavior of the video.
       *
       * @promise SetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */

      /**
       * Enable or disable the autopause behavior of this player.
       *
       * By default, when another video is played in the same browser, this
       * player will automatically pause. Unless you have a specific reason
       * for doing so, we recommend that you leave autopause set to the
       * default (`true`).
       *
       * @param {boolean} autopause
       * @return {SetAutopausePromise}
       */

    }, {
      key: "setAutopause",
      value: function setAutopause(autopause) {
        return this.set('autopause', autopause);
      }
      /**
       * A promise to get the buffered property of the video.
       *
       * @promise GetBufferedPromise
       * @fulfill {Array} Buffered Timeranges converted to an Array.
       */

      /**
       * Get the buffered property of the video.
       *
       * @return {GetBufferedPromise}
       */

    }, {
      key: "getBuffered",
      value: function getBuffered() {
        return this.get('buffered');
      }
      /**
       * @typedef {Object} CameraProperties
       * @prop {number} props.yaw - Number between 0 and 360.
       * @prop {number} props.pitch - Number between -90 and 90.
       * @prop {number} props.roll - Number between -180 and 180.
       * @prop {number} props.fov - The field of view in degrees.
       */

      /**
       * A promise to get the camera properties of the player.
       *
       * @promise GetCameraPromise
       * @fulfill {CameraProperties} The camera properties.
       */

      /**
       * For 360° videos get the camera properties for this player.
       *
       * @return {GetCameraPromise}
       */

    }, {
      key: "getCameraProps",
      value: function getCameraProps() {
        return this.get('cameraProps');
      }
      /**
       * A promise to set the camera properties of the player.
       *
       * @promise SetCameraPromise
       * @fulfill {Object} The camera was successfully set.
       * @reject {RangeError} The range was out of bounds.
       */

      /**
       * For 360° videos set the camera properties for this player.
       *
       * @param {CameraProperties} camera The camera properties
       * @return {SetCameraPromise}
       */

    }, {
      key: "setCameraProps",
      value: function setCameraProps(camera) {
        return this.set('cameraProps', camera);
      }
      /**
       * A representation of a chapter.
       *
       * @typedef {Object} VimeoChapter
       * @property {number} startTime The start time of the chapter.
       * @property {object} title The title of the chapter.
       * @property {number} index The place in the order of Chapters. Starts at 1.
       */

      /**
       * A promise to get chapters for the video.
       *
       * @promise GetChaptersPromise
       * @fulfill {VimeoChapter[]} The chapters for the video.
       */

      /**
       * Get an array of all the chapters for the video.
       *
       * @return {GetChaptersPromise}
       */

    }, {
      key: "getChapters",
      value: function getChapters() {
        return this.get('chapters');
      }
      /**
       * A promise to get the currently active chapter.
       *
       * @promise GetCurrentChaptersPromise
       * @fulfill {VimeoChapter|undefined} The current chapter for the video.
       */

      /**
       * Get the currently active chapter for the video.
       *
       * @return {GetCurrentChaptersPromise}
       */

    }, {
      key: "getCurrentChapter",
      value: function getCurrentChapter() {
        return this.get('currentChapter');
      }
      /**
       * A promise to get the color of the player.
       *
       * @promise GetColorPromise
       * @fulfill {string} The hex color of the player.
       */

      /**
       * Get the color for this player.
       *
       * @return {GetColorPromise}
       */

    }, {
      key: "getColor",
      value: function getColor() {
        return this.get('color');
      }
      /**
       * A promise to set the color of the player.
       *
       * @promise SetColorPromise
       * @fulfill {string} The color was successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */

      /**
       * Set the color of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       *
       * @param {string} color The hex or rgb color string to set.
       * @return {SetColorPromise}
       */

    }, {
      key: "setColor",
      value: function setColor(color) {
        return this.set('color', color);
      }
      /**
       * A representation of a cue point.
       *
       * @typedef {Object} VimeoCuePoint
       * @property {number} time The time of the cue point.
       * @property {object} data The data passed when adding the cue point.
       * @property {string} id The unique id for use with removeCuePoint.
       */

      /**
       * A promise to get the cue points of a video.
       *
       * @promise GetCuePointsPromise
       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */

      /**
       * Get an array of the cue points added to the video.
       *
       * @return {GetCuePointsPromise}
       */

    }, {
      key: "getCuePoints",
      value: function getCuePoints() {
        return this.get('cuePoints');
      }
      /**
       * A promise to get the current time of the video.
       *
       * @promise GetCurrentTimePromise
       * @fulfill {number} The current time in seconds.
       */

      /**
       * Get the current playback position in seconds.
       *
       * @return {GetCurrentTimePromise}
       */

    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.get('currentTime');
      }
      /**
       * A promise to set the current time of the video.
       *
       * @promise SetCurrentTimePromise
       * @fulfill {number} The actual current time that was set.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       */

      /**
       * Set the current playback position in seconds. If the player was
       * paused, it will remain paused. Likewise, if the player was playing,
       * it will resume playing once the video has buffered.
       *
       * You can provide an accurate time and the player will attempt to seek
       * to as close to that time as possible. The exact time will be the
       * fulfilled value of the promise.
       *
       * @param {number} currentTime
       * @return {SetCurrentTimePromise}
       */

    }, {
      key: "setCurrentTime",
      value: function setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
      }
      /**
       * A promise to get the duration of the video.
       *
       * @promise GetDurationPromise
       * @fulfill {number} The duration in seconds.
       */

      /**
       * Get the duration of the video in seconds. It will be rounded to the
       * nearest second before playback begins, and to the nearest thousandth
       * of a second after playback begins.
       *
       * @return {GetDurationPromise}
       */

    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.get('duration');
      }
      /**
       * A promise to get the ended state of the video.
       *
       * @promise GetEndedPromise
       * @fulfill {boolean} Whether or not the video has ended.
       */

      /**
       * Get the ended state of the video. The video has ended if
       * `currentTime === duration`.
       *
       * @return {GetEndedPromise}
       */

    }, {
      key: "getEnded",
      value: function getEnded() {
        return this.get('ended');
      }
      /**
       * A promise to get the loop state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the player is set to loop.
       */

      /**
       * Get the loop state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getLoop",
      value: function getLoop() {
        return this.get('loop');
      }
      /**
       * A promise to set the loop state of the player.
       *
       * @promise SetLoopPromise
       * @fulfill {boolean} The loop state that was set.
       */

      /**
       * Set the loop state of the player. When set to `true`, the player
       * will start over immediately once playback ends.
       *
       * @param {boolean} loop
       * @return {SetLoopPromise}
       */

    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        return this.set('loop', loop);
      }
      /**
       * A promise to set the muted state of the player.
       *
       * @promise SetMutedPromise
       * @fulfill {boolean} The muted state that was set.
       */

      /**
       * Set the muted state of the player. When set to `true`, the player
       * volume will be muted.
       *
       * @param {boolean} muted
       * @return {SetMutedPromise}
       */

    }, {
      key: "setMuted",
      value: function setMuted(muted) {
        return this.set('muted', muted);
      }
      /**
       * A promise to get the muted state of the player.
       *
       * @promise GetMutedPromise
       * @fulfill {boolean} Whether or not the player is muted.
       */

      /**
       * Get the muted state of the player.
       *
       * @return {GetMutedPromise}
       */

    }, {
      key: "getMuted",
      value: function getMuted() {
        return this.get('muted');
      }
      /**
       * A promise to get the paused state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the video is paused.
       */

      /**
       * Get the paused state of the player.
       *
       * @return {GetLoopPromise}
       */

    }, {
      key: "getPaused",
      value: function getPaused() {
        return this.get('paused');
      }
      /**
       * A promise to get the playback rate of the player.
       *
       * @promise GetPlaybackRatePromise
       * @fulfill {number} The playback rate of the player on a scale from 0.5 to 2.
       */

      /**
       * Get the playback rate of the player on a scale from `0.5` to `2`.
       *
       * @return {GetPlaybackRatePromise}
       */

    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.get('playbackRate');
      }
      /**
       * A promise to set the playbackrate of the player.
       *
       * @promise SetPlaybackRatePromise
       * @fulfill {number} The playback rate was set.
       * @reject {RangeError} The playback rate was less than 0.5 or greater than 2.
       */

      /**
       * Set the playback rate of the player on a scale from `0.5` to `2`. When set
       * via the API, the playback rate will not be synchronized to other
       * players or stored as the viewer's preference.
       *
       * @param {number} playbackRate
       * @return {SetPlaybackRatePromise}
       */

    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
      }
      /**
       * A promise to get the played property of the video.
       *
       * @promise GetPlayedPromise
       * @fulfill {Array} Played Timeranges converted to an Array.
       */

      /**
       * Get the played property of the video.
       *
       * @return {GetPlayedPromise}
       */

    }, {
      key: "getPlayed",
      value: function getPlayed() {
        return this.get('played');
      }
      /**
       * A promise to get the qualities available of the current video.
       *
       * @promise GetQualitiesPromise
       * @fulfill {Array} The qualities of the video.
       */

      /**
       * Get the qualities of the current video.
       *
       * @return {GetQualitiesPromise}
       */

    }, {
      key: "getQualities",
      value: function getQualities() {
        return this.get('qualities');
      }
      /**
       * A promise to get the current set quality of the video.
       *
       * @promise GetQualityPromise
       * @fulfill {string} The current set quality.
       */

      /**
       * Get the current set quality of the video.
       *
       * @return {GetQualityPromise}
       */

    }, {
      key: "getQuality",
      value: function getQuality() {
        return this.get('quality');
      }
      /**
       * A promise to set the video quality.
       *
       * @promise SetQualityPromise
       * @fulfill {number} The quality was set.
       * @reject {RangeError} The quality is not available.
       */

      /**
       * Set a video quality.
       *
       * @param {string} quality
       * @return {SetQualityPromise}
       */

    }, {
      key: "setQuality",
      value: function setQuality(quality) {
        return this.set('quality', quality);
      }
      /**
       * A promise to get the seekable property of the video.
       *
       * @promise GetSeekablePromise
       * @fulfill {Array} Seekable Timeranges converted to an Array.
       */

      /**
       * Get the seekable property of the video.
       *
       * @return {GetSeekablePromise}
       */

    }, {
      key: "getSeekable",
      value: function getSeekable() {
        return this.get('seekable');
      }
      /**
       * A promise to get the seeking property of the player.
       *
       * @promise GetSeekingPromise
       * @fulfill {boolean} Whether or not the player is currently seeking.
       */

      /**
       * Get if the player is currently seeking.
       *
       * @return {GetSeekingPromise}
       */

    }, {
      key: "getSeeking",
      value: function getSeeking() {
        return this.get('seeking');
      }
      /**
       * A promise to get the text tracks of a video.
       *
       * @promise GetTextTracksPromise
       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
       */

      /**
       * Get an array of the text tracks that exist for the video.
       *
       * @return {GetTextTracksPromise}
       */

    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return this.get('textTracks');
      }
      /**
       * A promise to get the embed code for the video.
       *
       * @promise GetVideoEmbedCodePromise
       * @fulfill {string} The `<iframe>` embed code for the video.
       */

      /**
       * Get the `<iframe>` embed code for the video.
       *
       * @return {GetVideoEmbedCodePromise}
       */

    }, {
      key: "getVideoEmbedCode",
      value: function getVideoEmbedCode() {
        return this.get('videoEmbedCode');
      }
      /**
       * A promise to get the id of the video.
       *
       * @promise GetVideoIdPromise
       * @fulfill {number} The id of the video.
       */

      /**
       * Get the id of the video.
       *
       * @return {GetVideoIdPromise}
       */

    }, {
      key: "getVideoId",
      value: function getVideoId() {
        return this.get('videoId');
      }
      /**
       * A promise to get the title of the video.
       *
       * @promise GetVideoTitlePromise
       * @fulfill {number} The title of the video.
       */

      /**
       * Get the title of the video.
       *
       * @return {GetVideoTitlePromise}
       */

    }, {
      key: "getVideoTitle",
      value: function getVideoTitle() {
        return this.get('videoTitle');
      }
      /**
       * A promise to get the native width of the video.
       *
       * @promise GetVideoWidthPromise
       * @fulfill {number} The native width of the video.
       */

      /**
       * Get the native width of the currently‐playing video. The width of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoWidthPromise}
       */

    }, {
      key: "getVideoWidth",
      value: function getVideoWidth() {
        return this.get('videoWidth');
      }
      /**
       * A promise to get the native height of the video.
       *
       * @promise GetVideoHeightPromise
       * @fulfill {number} The native height of the video.
       */

      /**
       * Get the native height of the currently‐playing video. The height of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoHeightPromise}
       */

    }, {
      key: "getVideoHeight",
      value: function getVideoHeight() {
        return this.get('videoHeight');
      }
      /**
       * A promise to get the vimeo.com url for the video.
       *
       * @promise GetVideoUrlPromise
       * @fulfill {number} The vimeo.com url for the video.
       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
       */

      /**
       * Get the vimeo.com url for the video.
       *
       * @return {GetVideoUrlPromise}
       */

    }, {
      key: "getVideoUrl",
      value: function getVideoUrl() {
        return this.get('videoUrl');
      }
      /**
       * A promise to get the volume level of the player.
       *
       * @promise GetVolumePromise
       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
       */

      /**
       * Get the current volume level of the player on a scale from `0` to `1`.
       *
       * Most mobile devices do not support an independent volume from the
       * system volume. In those cases, this method will always return `1`.
       *
       * @return {GetVolumePromise}
       */

    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.get('volume');
      }
      /**
       * A promise to set the volume level of the player.
       *
       * @promise SetVolumePromise
       * @fulfill {number} The volume was set.
       * @reject {RangeError} The volume was less than 0 or greater than 1.
       */

      /**
       * Set the volume of the player on a scale from `0` to `1`. When set
       * via the API, the volume level will not be synchronized to other
       * players or stored as the viewer’s preference.
       *
       * Most mobile devices do not support setting the volume. An error will
       * *not* be triggered in that situation.
       *
       * @param {number} volume
       * @return {SetVolumePromise}
       */

    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        return this.set('volume', volume);
      }
    }]);

    return Player;
  }(); // Setup embed only if this is not a node environment


  if (!isNode) {
    screenfull = initializeScreenfull();
    initializeEmbeds();
    resizeEmbeds();
  }

  return Player;

})));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":4}],2:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],3:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],4:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":3,"timers":4}],5:[function(require,module,exports){
"use strict";

require("impv-resources/src/js/inner");

},{"impv-resources/src/js/inner":8}],6:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

document.addEventListener('DOMContentLoaded', function () {
  var apiSrc = 'https://www.brighttalk.com/clients/js/player-embed/player-embed.js';
  var modals = document.querySelectorAll('.brighttalk-modal');

  var onShownModal = function onShownModal(e) {
    var modal = this;
    var holder = modal.querySelector('.iframe-holder');

    if (holder) {
      var content = holder.getAttribute('data-brighttalk-temp');

      if (content) {
        // empty holder
        holder.innerHTML = ''; // insert content with settings

        holder.insertAdjacentHTML('beforeend', content.trim());
        var wrapper = holder.querySelector('.jsBrightTALKEmbedWrapper ');

        if (wrapper) {
          var s = document.createElement('script');
          s.src = apiSrc; // insert brighttalk js script

          wrapper.appendChild(s);
        }
      }
    }
  };

  var onHideModal = function onHideModal(e) {
    var modal = this;
    var holder = modal.querySelector('.iframe-holder');

    if (holder) {
      holder.innerHTML = '';
    }
  };

  _toConsumableArray(modals).forEach(function (modal) {
    var $modal = jQuery(modal);
    $modal.on('shown.bs.modal', onShownModal);
    $modal.on('hide.bs.modal', onHideModal);
  });
});

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SlickWithIndicator =
/*#__PURE__*/
function () {
  function SlickWithIndicator(holder) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SlickWithIndicator);

    this.options = Object.assign({
      slick: '.slider',
      indicator: '.slides-indicator',
      slickOpts: {}
    }, opts);

    if (holder) {
      this.holder = holder;
      this.init();
    }
  }

  _createClass(SlickWithIndicator, [{
    key: "init",
    value: function init() {
      this.findElems();
      this.attachEvents();
    }
  }, {
    key: "findElems",
    value: function findElems() {
      this.$slickSlider = jQuery(this.holder.querySelector(this.options.slick));
      this.indicator = this.holder.querySelector(this.options.indicator);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.initTimer = null;

      this.onSlickInit = function (e, s) {
        // set timeout fixes this issue
        // https://github.com/kenwheeler/slick/issues/1802
        clearTimeout(_this.initTimer);
        _this.initTimer = setTimeout(function () {
          var currentSlide = s.currentSlide;

          if (_this.indicator) {
            _this.makeIndicator({
              current: currentSlide,
              step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
            });
          }
        }, 0);
      };

      this.onSlickBeforeChange = function (e, s, cur, next) {
        if (_this.indicator) {
          _this.makeIndicator({
            current: next,
            step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
          });
        }
      };

      this.$slickSlider.on('init', this.onSlickInit).slick(this.options.slickOpts).on('beforeChange', this.onSlickBeforeChange);
    }
  }, {
    key: "setProps",
    value: function setProps(elem) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (elem) {
        props.forEach(function (d) {
          var prop = d.prop,
              val = d.val;
          elem.style.setProperty(prop, val);
        });
      }
    }
  }, {
    key: "calcProps",
    value: function calcProps(_ref) {
      var current = _ref.current,
          step = _ref.step;
      var totalSteps = this.getDotCount();
      var currentStep = Math.floor(current / step);
      return {
        width: "".concat(1 / totalSteps * 100, "%"),
        left: "".concat(currentStep / totalSteps * 100, "%")
      };
    }
  }, {
    key: "buildProps",
    value: function buildProps() {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return [{
        prop: '--indicator-width',
        val: width
      }, {
        prop: '--indicator-left',
        val: left
      }];
    }
  }, {
    key: "makeIndicator",
    value: function makeIndicator() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        current: 1,
        step: 1
      };

      if (this.indicator) {
        // calc width and left
        var _this$calcProps = this.calcProps(opts),
            width = _this$calcProps.width,
            left = _this$calcProps.left; // build array with props


        var props = this.buildProps(width, left); // apply props to indicator

        this.setProps(this.indicator, props);
      }
    }
  }, {
    key: "getDotCount",
    value: function getDotCount() {
      var _ = this.$slickSlider.slick('getSlick');

      var breakPoint = 0;
      var counter = 0;
      var pagerQty = 0;

      if (_.options.infinite === true) {
        if (_.slideCount <= _.options.slidesToShow) {
          ++pagerQty;
        } else {
          while (breakPoint < _.slideCount) {
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
          }
        }
      } else if (_.options.centerMode === true) {
        pagerQty = _.slideCount;
      } else if (!_.options.asNavFor) {
        pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }

      return pagerQty;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.initTimer);
      this.$slickSlider.off('init', this.onSlickInit).off('beforeChange', this.onSlickBeforeChange).slick('unslick');
    }
  }], [{
    key: "jqueryInit",
    value: function jqueryInit(elOrSelector) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      jQuery(elOrSelector).each(function (i, el) {
        jQuery(el).data('SlickWithIndicator', new SlickWithIndicator(el, opts));
      });
    }
  }, {
    key: "jqueryDestroy",
    value: function jqueryDestroy(elOrSelector) {
      jQuery(elOrSelector).each(function (i, el) {
        var $el = jQuery(el);
        var data = $el.data('SlickWithIndicator');

        if (data) {
          data.destroy();
          $el.removeData('SlickWithIndicator');
        }
      });
    }
  }]);

  return SlickWithIndicator;
}();

exports["default"] = SlickWithIndicator;

},{}],8:[function(require,module,exports){
(function (global){
"use strict";

var _dropdownSelect = _interopRequireDefault(require("impv/src/js/components/dropdown-select"));

var _marketoForm = _interopRequireDefault(require("impv/src/js/components/marketo-form"));

var _slickWithIndicator = _interopRequireDefault(require("./components/slick-with-indicator"));

require("../../../impv/src/js/components/vimeo-modals-controller");

require("../../../impv/src/js/components/youtube-modals-controller");

require("./components/brighttalk-video");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

jQuery(function () {
  initSlick();
  maybeInitStickyScrollBlock();
}); //if there is no marketo form on the page init initStickyScrollBlock here, if there is form init in marketoFormActions

function maybeInitStickyScrollBlock() {
  var formHolder = jQuery('.container.form-section');

  if (!formHolder.length) {
    initStickyScrollBlock();
  }
}

document.addEventListener('form2init', marketoFormActions);

function marketoFormActions() {
  $(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            initDropDown();

            _marketoForm["default"].findById($('#form-info').attr('data-form-id')).then(function (form) {
              form.hideField('Policy_Consent__c').registerEvent('focusout', 'fullNameTrendemon', function () {
                if (!form.visited) {
                  form.visited = true;
                  form.showField('Policy_Consent__c', 400);
                }
              });
              form.onLoad(function () {
                if ($('#lang-drop-down-div').length) {
                  var dropDownElem = $('#lang-drop-down-div').css('display', 'inline-flex');
                  $('#lang-drop-down-div').remove();
                  dropDownElem.insertBefore($(form.formElem).find('.mktoButtonWrap'));
                  initDropDownForm(form);
                }

                initStickyScrollBlock();
              });

              if ($('#form-info').data('tool-type') === 'imperva_snapshot') {
                form.snapShotValidation();
              } else {
                form.eCustomsValidation($('#form-info').data('thankyou'));
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
} // initialize sticky blocks on scroll


function initStickyScrollBlock() {
  jQuery('.grey-box:not(.cta-top .grey-box)').stickyScrollBlock({
    container: '.row-main',
    showAfterScrolled: false,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });
}

function initDropDownForm(form) {
  var dropdown = new _dropdownSelect["default"]();
  dropdown.on('select_changed', function () {
    var selectedLang = $('#lang-drop-down-div .dropdown-select-btn').attr('data-value');
    var newThankYou = $('#form-info').attr('data-thankyou').replace(/lang=.+&/, 'lang=' + selectedLang + '&');
    form.setThankyouUrl(newThankYou);
  });
}

function initDropDown() {
  var dropdown = new _dropdownSelect["default"]();
  dropdown.on('select_changed', function (parent$, item$) {
    if ($('.resource-download-btn').length != -1) {
      $('.resource-download-btn').attr('href', item$.data('source'));
    }
  });
}

function initSlick() {
  ResponsiveHelper.addRange({
    '768..1199': {
      on: function on() {
        _slickWithIndicator["default"].jqueryInit('.featured-assets', {
          slick: '.featured-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            pauseOnHover: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        _slickWithIndicator["default"].jqueryDestroy('.featured-assets');
      }
    }
  });

  _slickWithIndicator["default"].jqueryInit('.related-row', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 3,
      slidesToShow: 3,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  jQuery('.dotted').dotdotdot({
    ellipsis: "[\u2026]",
    height: null,
    tolerance: 0,
    truncate: 'word',
    watch: 'true'
  });
});
/*
 * jQuery sticky box plugin
 */

(function ($, $win) {
  'use strict';

  function StickyScrollBlock($stickyBox, options) {
    this.options = options;
    this.$stickyBox = $stickyBox;
    this.init();
  }

  var StickyScrollBlockPrototype = {
    init: function init() {
      this.findElements();
      this.attachEvents();
      this.makeCallback('onInit');
    },
    findElements: function findElements() {
      // find parent container in which will be box move
      this.$container = this.$stickyBox.closest(this.options.container); // define box wrap flag

      this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight; // define box move flag

      this.moveInContainer = !!this.$container.length; // wrapping box to set place in content

      if (this.isWrap) {
        this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
      } //define block to add active class


      this.parentForActive = this.getParentForActive();
      this.isInit = true;
    },
    attachEvents: function attachEvents() {
      var self = this; // bind events

      this.onResize = function () {
        if (!self.isInit) return;
        self.resetState();
        self.recalculateOffsets();
        self.checkStickyPermission();
        self.scrollHandler();
      };

      this.onScroll = function () {
        self.scrollHandler();
      }; // initial handler call


      this.onResize(); // handle events

      $win.on('load resize orientationchange', this.onResize).on('scroll', this.onScroll);
    },
    defineExtraTop: function defineExtraTop() {
      // define box's extra top dimension
      var extraTop;

      if (typeof this.options.extraTop === 'number') {
        extraTop = this.options.extraTop;
      } else if (typeof this.options.extraTop === 'function') {
        extraTop = this.options.extraTop();
      }

      this.extraTop = this.options.positionType === 'absolute' ? extraTop : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
    },
    checkStickyPermission: function checkStickyPermission() {
      // check the permission to set sticky
      this.isStickyEnabled = this.moveInContainer ? this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom : true;
    },
    getParentForActive: function getParentForActive() {
      if (this.isWrap) {
        return this.$stickyBoxWrap;
      }

      if (this.$container.length) {
        return this.$container;
      }

      return this.$stickyBox;
    },
    getWrapClass: function getWrapClass() {
      // get set of container classes
      try {
        return this.$stickyBox.attr('class').split(' ').map(function (name) {
          return 'sticky-wrap-' + name;
        }).join(' ');
      } catch (err) {
        return 'sticky-wrap';
      }
    },
    resetState: function resetState() {
      // reset dimensions and state
      this.stickyFlag = false;
      this.$stickyBox.css({
        '-webkit-transition': '',
        '-webkit-transform': '',
        transition: '',
        transform: '',
        position: '',
        width: '',
        left: '',
        top: ''
      }).removeClass(this.options.activeClass);

      if (this.isWrap) {
        this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
      }

      if (this.moveInContainer) {
        this.$container.removeClass(this.options.activeClass);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      // define box and container dimensions
      this.winParams = this.getWindowParams();
      this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());
      this.defineExtraTop();
    },
    getBoxOffsets: function getBoxOffsets() {
      var boxOffset = this.$stickyBox.offset();
      var boxPosition = this.$stickyBox.position();
      return {
        // sticky box offsets
        boxOffsetLeft: boxOffset.left,
        boxOffsetTop: boxOffset.top,
        // sticky box positions
        boxTopPosition: boxPosition.top,
        boxLeftPosition: boxPosition.left,
        // sticky box width/height
        boxFullHeight: this.$stickyBox.outerHeight(true),
        boxHeight: this.$stickyBox.outerHeight(),
        boxWidth: this.$stickyBox.outerWidth()
      };
    },
    getContainerOffsets: function getContainerOffsets() {
      var containerOffset = this.moveInContainer ? this.$container.offset() : null;
      return containerOffset ? {
        // container offsets
        containerOffsetLeft: containerOffset.left,
        containerOffsetTop: containerOffset.top,
        // container height
        containerHeight: this.$container.outerHeight()
      } : {};
    },
    getWindowParams: function getWindowParams() {
      return {
        height: window.innerHeight || document.documentElement.clientHeight
      };
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      this.isInit = false; // remove event handlers and styles

      $win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
      this.resetState();
      this.$stickyBox.removeData('StickyScrollBlock');

      if (this.isWrap) {
        this.$stickyBox.unwrap();
      }

      this.makeCallback('onDestroy');
    }
  };
  var stickyMethods = {
    fixed: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop - (this.options.showAfterScrolled ? this.extraTop : 0) - (this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            position: this.options.positionType
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.setDynamicPosition();
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.stickyFlag = false;
          this.resetState();
          this.makeCallback('fixedOff');
        }
      },
      setDynamicPosition: function setDynamicPosition() {
        this.$stickyBox.css({
          top: this.getTopPosition(),
          left: this.data.boxOffsetLeft - $win.scrollLeft()
        });
      },
      getTopPosition: function getTopPosition() {
        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          return Math.min(this.extraTop, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop);
        } else {
          return this.extraTop;
        }
      }
    },
    absolute: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            transition: 'transform ' + this.options.animSpeed + 's ease',
            '-webkit-transition': 'transform ' + this.options.animSpeed + 's ease'
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.clearTimer();
        this.timer = setTimeout(function () {
          this.setDynamicPosition();
        }.bind(this), this.options.animDelay * 1000);
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.clearTimer();
          this.stickyFlag = false;
          this.timer = setTimeout(function () {
            this.setDynamicPosition();
            setTimeout(function () {
              this.resetState();
            }.bind(this), this.options.animSpeed * 1000);
          }.bind(this), this.options.animDelay * 1000);
          this.makeCallback('fixedOff');
        }
      },
      clearTimer: function clearTimer() {
        clearTimeout(this.timer);
      },
      setDynamicPosition: function setDynamicPosition() {
        var topPosition = Math.max(0, this.getTopPosition());
        this.$stickyBox.css({
          transform: 'translateY(' + topPosition + 'px)',
          '-webkit-transform': 'translateY(' + topPosition + 'px)'
        });
      },
      getTopPosition: function getTopPosition() {
        var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          var diffOffset = Math.abs(Math.min(0, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop - this.extraTop));
          return currTopPosition - diffOffset;
        } else {
          return currTopPosition;
        }
      }
    }
  }; // jQuery plugin interface

  $.fn.stickyScrollBlock = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      container: null,
      positionType: 'fixed',
      // 'fixed' or 'absolute'
      activeClass: 'fixed-position',
      setBoxHeight: true,
      showAfterScrolled: false,
      extraTop: 0,
      extraBottom: 0,
      animDelay: 0.1,
      animSpeed: 0.2
    }, opt);
    return this.each(function () {
      var $stickyBox = jQuery(this);
      var instance = $stickyBox.data('StickyScrollBlock');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
        $stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  }; // module exports


  window.StickyScrollBlock = StickyScrollBlock;
})(jQuery, jQuery(window));

(function (root, factory) {
  // if (typeof define === 'function' && define.amd) {
  // 	define(['jquery'], factory);
  // } else if (typeof exports === 'object') {
  // 	module.exports = factory(require('jquery'));
  // } else {
  // 	root.jquery_dotdotdot_js = factory(root.jQuery);
  // }
  factory(jQuery);
})(void 0, function (jQuery) {
  /*
   *	jQuery dotdotdot 3.2.2
   *	@requires jQuery 1.7.0 or later
   *
   *	dotdotdot.frebsite.nl
   *
   *	Copyright (c) Fred Heusschen
   *	www.frebsite.nl
   *
   *	License: CC-BY-NC-4.0
   *	http://creativecommons.org/licenses/by-nc/4.0/
   */
  !function (t) {
    'use strict';

    function e() {
      h = t(window), s = {}, o = {}, r = {}, t.each([s, o, r], function (t, e) {
        e.add = function (t) {
          t = t.split(' ');

          for (var i = 0, n = t.length; i < n; i++) {
            e[t[i]] = e.ddd(t[i]);
          }
        };
      }), s.ddd = function (t) {
        return 'ddd-' + t;
      }, s.add('truncated keep'), o.ddd = function (t) {
        return 'ddd-' + t;
      }, r.ddd = function (t) {
        return t + '.ddd';
      }, r.add('resize'), e = function e() {};
    }

    var i = 'dotdotdot',
        n = '3.2.2';

    if (!(t[i] && t[i].version > n)) {
      t[i] = function (t, e) {
        this.$dot = t, this.api = ['getInstance', 'truncate', 'restore', 'destroy', 'watch', 'unwatch'], this.opts = e;
        var n = this.$dot.data(i);
        return n && n.destroy(), this.init(), this.truncate(), this.opts.watch && this.watch(), this;
      }, t[i].version = n, t[i].uniqueId = 0, t[i].defaults = {
        ellipsis: '… ',
        callback: function callback(t) {},
        truncate: 'word',
        tolerance: 0,
        keep: null,
        watch: 'window',
        height: null
      }, t[i].prototype = {
        init: function init() {
          this.watchTimeout = null, this.watchInterval = null, this.uniqueId = t[i].uniqueId++, this.originalStyle = this.$dot.attr('style') || '', this.originalContent = this._getOriginalContent(), 'break-word' !== this.$dot.css('word-wrap') && this.$dot.css('word-wrap', 'break-word'), 'nowrap' === this.$dot.css('white-space') && this.$dot.css('white-space', 'normal'), null === this.opts.height && (this.opts.height = this._getMaxHeight()), 'string' == typeof this.opts.ellipsis && (this.opts.ellipsis = document.createTextNode(this.opts.ellipsis));
        },
        getInstance: function getInstance() {
          return this;
        },
        truncate: function truncate() {
          this.$inner = this.$dot.wrapInner('<div />').children().css({
            display: 'block',
            height: 'auto',
            width: 'auto',
            border: 'none',
            padding: 0,
            margin: 0
          }), this.$inner.empty().append(this.originalContent.clone(!0)), this.maxHeight = this._getMaxHeight();
          var t = !1;
          return this._fits() || (t = !0, this._truncateToNode(this.$inner[0])), this.$dot[t ? 'addClass' : 'removeClass'](s.truncated), this.$inner.replaceWith(this.$inner.contents()), this.$inner = null, this.opts.callback.call(this.$dot[0], t), t;
        },
        restore: function restore() {
          this.unwatch(), this.$dot.empty().append(this.originalContent).attr('style', this.originalStyle).removeClass(s.truncated);
        },
        destroy: function destroy() {
          this.restore(), this.$dot.data(i, null);
        },
        watch: function watch() {
          var t = this;
          this.unwatch();
          var e = {};
          'window' == this.opts.watch ? h.on(r.resize + t.uniqueId, function (i) {
            t.watchTimeout && clearTimeout(t.watchTimeout), t.watchTimeout = setTimeout(function () {
              e = t._watchSizes(e, h, 'width', 'height');
            }, 100);
          }) : this.watchInterval = setInterval(function () {
            e = t._watchSizes(e, t.$dot, 'innerWidth', 'innerHeight');
          }, 500);
        },
        unwatch: function unwatch() {
          h.off(r.resize + this.uniqueId), this.watchInterval && clearInterval(this.watchInterval), this.watchTimeout && clearTimeout(this.watchTimeout);
        },
        _api: function _api() {
          var e = this,
              i = {};
          return t.each(this.api, function (t) {
            var n = this;

            i[n] = function () {
              var t = e[n].apply(e, arguments);
              return 'undefined' == typeof t ? i : t;
            };
          }), i;
        },
        _truncateToNode: function _truncateToNode(e) {
          var i = [],
              n = [];

          if (t(e).contents().each(function () {
            var e = t(this);

            if (!e.hasClass(s.keep)) {
              var o = document.createComment('');
              e.replaceWith(o), n.push(this), i.push(o);
            }
          }), n.length) {
            for (var o = 0; o < n.length; o++) {
              t(i[o]).replaceWith(n[o]), t(n[o]).append(this.opts.ellipsis);

              var r = this._fits();

              if (t(this.opts.ellipsis, n[o]).remove(), !r) {
                if ('node' == this.opts.truncate && o > 1) return void t(n[o - 2]).remove();
                break;
              }
            }

            for (var h = o; h < i.length; h++) {
              t(i[h]).remove();
            }

            var a = n[Math.max(0, Math.min(o, n.length - 1))];

            if (1 == a.nodeType) {
              var d = t('<' + a.nodeName + ' />');
              d.append(this.opts.ellipsis), t(a).replaceWith(d), this._fits() ? d.replaceWith(a) : (d.remove(), a = n[Math.max(0, o - 1)]);
            }

            1 == a.nodeType ? this._truncateToNode(a) : this._truncateToWord(a);
          }
        },
        _truncateToWord: function _truncateToWord(t) {
          for (var e = t, i = this, n = this.__getTextContent(e), s = n.indexOf(' ') !== -1 ? ' ' : '　', o = n.split(s), r = '', h = o.length; h >= 0; h--) {
            if (r = o.slice(0, h).join(s), i.__setTextContent(e, i._addEllipsis(r)), i._fits()) {
              'letter' == i.opts.truncate && (i.__setTextContent(e, o.slice(0, h + 1).join(s)), i._truncateToLetter(e));
              break;
            }
          }
        },
        _truncateToLetter: function _truncateToLetter(t) {
          for (var e = this, i = this.__getTextContent(t), n = i.split(''), s = '', o = n.length; o >= 0 && (s = n.slice(0, o).join(''), !s.length || (e.__setTextContent(t, e._addEllipsis(s)), !e._fits())); o--) {
            ;
          }
        },
        _fits: function _fits() {
          return this.$inner.innerHeight() <= this.maxHeight + this.opts.tolerance;
        },
        _addEllipsis: function _addEllipsis(e) {
          for (var i = [' ', '　', ',', ';', '.', '!', '?']; t.inArray(e.slice(-1), i) > -1;) {
            e = e.slice(0, -1);
          }

          return e += this.__getTextContent(this.opts.ellipsis);
        },
        _getOriginalContent: function _getOriginalContent() {
          var e = this;
          return this.$dot.find('script, style').addClass(s.keep), this.opts.keep && this.$dot.find(this.opts.keep).addClass(s.keep), this.$dot.find('*').not('.' + s.keep).add(this.$dot).contents().each(function () {
            var i = this,
                n = t(this);

            if (3 == i.nodeType) {
              if ('' == t.trim(e.__getTextContent(i))) {
                if (n.parent().is('table, thead, tbody, tfoot, tr, dl, ul, ol, video')) return void n.remove();
                if (n.prev().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (n.next().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (!n.prev().length) return void n.remove();
                if (!n.next().length) return void n.remove();
              }
            } else 8 == i.nodeType && n.remove();
          }), this.$dot.contents();
        },
        _getMaxHeight: function _getMaxHeight() {
          if ('number' == typeof this.opts.height) return this.opts.height;

          for (var t = ['maxHeight', 'height'], e = 0, i = 0; i < t.length; i++) {
            if (e = window.getComputedStyle(this.$dot[0])[t[i]], 'px' == e.slice(-2)) {
              e = parseFloat(e);
              break;
            }
          }

          var t = [];

          switch (this.$dot.css('boxSizing')) {
            case 'border-box':
              t.push('borderTopWidth'), t.push('borderBottomWidth');

            case 'padding-box':
              t.push('paddingTop'), t.push('paddingBottom');
          }

          for (var i = 0; i < t.length; i++) {
            var n = window.getComputedStyle(this.$dot[0])[t[i]];
            'px' == n.slice(-2) && (e -= parseFloat(n));
          }

          return Math.max(e, 0);
        },
        _watchSizes: function _watchSizes(t, e, i, n) {
          if (this.$dot.is(':visible')) {
            var s = {
              width: e[i](),
              height: e[n]()
            };
            return t.width == s.width && t.height == s.height || this.truncate(), s;
          }

          return t;
        },
        __getTextContent: function __getTextContent(t) {
          for (var e = ['nodeValue', 'textContent', 'innerText'], i = 0; i < e.length; i++) {
            if ('string' == typeof t[e[i]]) return t[e[i]];
          }

          return '';
        },
        __setTextContent: function __setTextContent(t, e) {
          for (var i = ['nodeValue', 'textContent', 'innerText'], n = 0; n < i.length; n++) {
            t[i[n]] = e;
          }
        }
      }, t.fn[i] = function (n) {
        return e(), n = t.extend(!0, {}, t[i].defaults, n), this.each(function () {
          t(this).data(i, new t[i](t(this), n)._api());
        });
      };
      var s, o, r, h;
    }
  }(jQuery);
  return true;
});
/*
 * Responsive Layout helper
 */


window.ResponsiveHelper = function ($) {
  // init variables
  var handlers = [],
      prevWinWidth,
      win = $(window),
      nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = win.width();

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }

  win.bind('load resize orientationchange', resizeHandler); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}(jQuery);
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/
 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */


(function (i) {
  'use strict';

  'function' == typeof define && define.amd ? define(['jquery'], i) : 'undefined' != typeof exports ? module.exports = i((typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)) : i(jQuery);
})(function (i) {
  'use strict';

  var e = window.Slick || {};
  e = function () {
    function e(e, o) {
      var s,
          n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(e),
        appendDots: i(e),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: 'slick-dots',
        draggable: !0,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = 'hidden', n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = 'visibilitychange', n.windowWidth = 0, n.windowTimer = null, s = i(e).data('slick') || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, 'undefined' != typeof document.mozHidden ? (n.hidden = 'mozHidden', n.visibilityChange = 'mozvisibilitychange') : 'undefined' != typeof document.webkitHidden && (n.hidden = 'webkitHidden', n.visibilityChange = 'webkitvisibilitychange'), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    }

    var t = 0;
    return e;
  }(), e.prototype.activateADA = function () {
    var i = this;
    i.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      tabindex: '0'
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ('boolean' == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), 'number' == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;
    s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = 'translate(' + i + 'px, 0px)', s.$slideTrack.css(o)) : (o[s.animType] = 'translate(0px,' + i + 'px)', s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = 'translate3d(' + e + 'px, 0px, 0px)' : o[s.animType] = 'translate3d(0px,' + e + 'px, 0px)', s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this,
        o = t.getNavTarget();
    null !== o && 'object' == _typeof(o) && o.each(function () {
      var t = i(this).slick('getSlick');
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};
    e.options.fade === !1 ? t[e.transitionType] = e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase : t[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass('slick-arrow'), e.$nextArrow = i(e.options.nextArrow).addClass('slick-arrow'), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true')) : e.$prevArrow.add(e.$nextArrow).addClass('slick-hidden').attr({
      'aria-disabled': 'true',
      tabindex: '-1'
    }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;

    if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
      for (o.$slider.addClass('slick-dotted'), t = i('<ul />').addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i('<li />').append(o.options.customPaging.call(this, o, e)));
      }

      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find('li').first().addClass('slick-active');
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ':not(.slick-cloned)').addClass('slick-slide'), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e).data('originalStyling', i(t).attr('style') || '');
    }), e.$slider.addClass('slick-slider'), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css('opacity', 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass('draggable');
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;

    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement('div');

        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement('div');

          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }

          d.appendChild(a);
        }

        o.appendChild(d);
      }

      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + '%',
        display: 'inline-block'
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();

    if ('window' === r.respondTo ? n = a : 'slider' === r.respondTo ? n = d : 'min' === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;

      for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }

      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger('breakpoint', [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);

    switch (l.is('a') && e.preventDefault(), l.is('li') || (l = l.closest('li')), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case 'previous':
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;

      case 'next':
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;

      case 'index':
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger('focus');
        break;

      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e,
        t,
        o = this;
    if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var s in e) {
      if (i < e[s]) {
        i = t;
        break;
      }

      t = e[s];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i('li', e.$dots).off('click.slick', e.changeSlide).off('mouseenter.slick', i.proxy(e.interrupt, e, !0)).off('mouseleave.slick', i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off('keydown.slick', e.keyHandler)), e.$slider.off('focus.slick blur.slick'), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide), e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off('keydown.slick', e.keyHandler), e.$nextArrow && e.$nextArrow.off('keydown.slick', e.keyHandler))), e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler), e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler), e.$list.off('touchend.slick mouseup.slick', e.swipeHandler), e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler), e.$list.off('click.slick', e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off('click.slick', e.selectHandler), i(window).off('orientationchange.slick.slick-' + e.instanceUid, e.orientationChange), i(window).off('resize.slick.slick-' + e.instanceUid, e.resize), i('[draggable!=true]', e.$slideTrack).off('dragstart', e.preventDefault), i(window).off('load.slick.slick-' + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.off('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;
    e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr('style'), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    var e = this;
    e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i('.slick-cloned', t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
      i(this).attr('style', i(this).data('originalStyling'));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass('slick-slider'), t.$slider.removeClass('slick-initialized'), t.$slider.removeClass('slick-dotted'), t.unslicked = !0, e || t.$slider.trigger('destroy', [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};
    t[e.transitionType] = '', e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    t.cssTransitions === !1 ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    e.cssTransitions === !1 ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (t) {
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && o.is(':focus') && (e.focussed = !0, e.autoPlay());
      }, 0);
    }).on('blur.slick', '*', function (t) {
      i(this);
      e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay());
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    var i = this;
    return i.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;
    if (i.options.infinite === !0) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (i.options.centerMode === !0) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    var e = this;
    return e.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];

    for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }

    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o,
        s,
        n = this;
    return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find('.slick-slide').each(function (e, s) {
      var r, l, d;
      if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1;
    }), e = Math.abs(i(t).attr('data-slick-index') - n.currentSlide) || 1) : n.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    var t = this;
    t.changeSlide({
      data: {
        message: 'index',
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass('slick-initialized') || (i(t.$slider).addClass('slick-initialized'), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger('init', [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });
    e.$slides.add(e.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      tabindex: '-1'
    }).find('a, input, button, select').attr({
      tabindex: '-1'
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find('.slick-cloned')).each(function (t) {
      var s = o.indexOf(t);

      if (i(this).attr({
        role: 'tabpanel',
        id: 'slick-slide' + e.instanceUid + t,
        tabindex: -1
      }), s !== -1) {
        var n = 'slick-slide-control' + e.instanceUid + s;
        i('#' + n).length && i(this).attr({
          'aria-describedby': n
        });
      }
    }), e.$dots.attr('role', 'tablist').find('li').each(function (s) {
      var n = o[s];
      i(this).attr({
        role: 'presentation'
      }), i(this).find('button').first().attr({
        role: 'tab',
        id: 'slick-slide-control' + e.instanceUid + s,
        'aria-controls': 'slick-slide' + e.instanceUid + n,
        'aria-label': s + 1 + ' of ' + t,
        'aria-selected': null,
        tabindex: '-1'
      });
    }).eq(e.currentSlide).find('button').attr({
      'aria-selected': 'true',
      tabindex: '0'
    }).end());

    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.options.focusOnChange ? e.$slides.eq(s).attr({
        tabindex: '0'
      }) : e.$slides.eq(s).removeAttr('tabindex');
    }

    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off('click.slick').on('click.slick', {
      message: 'previous'
    }, i.changeSlide), i.$nextArrow.off('click.slick').on('click.slick', {
      message: 'next'
    }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on('keydown.slick', i.keyHandler), i.$nextArrow.on('keydown.slick', i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i('li', e.$dots).on('click.slick', {
      message: 'index'
    }, e.changeSlide), e.options.accessibility === !0 && e.$dots.on('keydown.slick', e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i('li', e.$dots).on('mouseenter.slick', i.proxy(e.interrupt, e, !0)).on('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.on('mouseleave.slick', i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, e.swipeHandler), e.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, e.swipeHandler), e.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('click.slick', e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), i(window).on('orientationchange.slick.slick-' + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on('resize.slick.slick-' + e.instanceUid, i.proxy(e.resize, e)), i('[draggable!=true]', e.$slideTrack).on('dragstart', e.preventDefault), i(window).on('load.slick.slick-' + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match('TEXTAREA|INPUT|SELECT') || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'next' : 'previous'
      }
    }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'previous' : 'next'
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i('img[data-lazy]', e).each(function () {
        var e = i(this),
            t = i(this).attr('data-lazy'),
            o = i(this).attr('data-srcset'),
            s = i(this).attr('data-sizes') || r.$slider.attr('data-sizes'),
            n = document.createElement('img');
        n.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr('srcset', o), s && e.attr('sizes', s)), e.attr('src', t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            }), r.$slider.trigger('lazyLoaded', [r, e, t]);
          });
        }, n.onerror = function () {
          e.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), r.$slider.trigger('lazyLoadError', [r, e, t]);
        }, n.src = t;
      });
    }

    var t,
        o,
        s,
        n,
        r = this;
    if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find('.slick-slide').slice(s, n), 'anticipated' === r.options.lazyLoad) for (var l = s - 1, d = n, a = r.$slider.find('.slick-slide'), c = 0; c < r.options.slidesToScroll; c++) {
      l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
    }
    e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find('.slick-slide'), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find('.slick-cloned').slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find('.slick-cloned').slice(r.options.slidesToShow * -1), e(o));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass('slick-loading'), i.initUI(), 'progressive' === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'next'
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;

    if (!t.unslicked && (t.$slider.trigger('afterChange', [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
      var o = i(t.$slides.get(t.currentSlide));
      o.attr('tabindex', 0).focus();
    }
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'previous'
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i('img[data-lazy]', l.$slider);
    d.length ? (t = d.first(), o = t.attr('data-lazy'), s = t.attr('data-srcset'), n = t.attr('data-sizes') || l.$slider.attr('data-sizes'), r = document.createElement('img'), r.onload = function () {
      s && (t.attr('srcset', s), n && t.attr('sizes', n)), t.attr('src', o).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading'), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger('lazyLoaded', [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), l.$slider.trigger('lazyLoadError', [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger('allImagesLoaded', [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: 'index',
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;

    if ('array' === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || 'window';

      for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }

          s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }

      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass('slick-slide'), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger('reInit', [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    return 'boolean' == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit());
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};
    o.options.rtl === !0 && (i = -i), e = 'left' == o.positionProp ? Math.ceil(i) + 'px' : '0px', t = 'top' == o.positionProp ? Math.ceil(i) + 'px' : '0px', s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = 'translate(' + e + ', ' + t + ')', o.$slideTrack.css(s)) : (s[o.animType] = 'translate3d(' + e + ', ' + t + ', 0px)', o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
      padding: '0px ' + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
      padding: i.options.centerPadding + ' 0px'
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children('.slick-slide').length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children('.slick-slide').length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    i.options.variableWidth === !1 && i.$slideTrack.children('.slick-slide').width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
        position: 'relative',
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: 'relative',
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css('height', e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
    if ('object' === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = 'multiple') : 'string' === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], 'responsive' === arguments[0] && 'array' === i.type(arguments[1]) ? n = 'responsive' : 'undefined' != typeof arguments[1] && (n = 'single')), 'single' === n) r.options[o] = s;else if ('multiple' === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ('responsive' === n) for (t in s) {
      if ('array' !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }

        r.options.responsive.push(s[t]);
      }
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger('setPosition', [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;
    i.positionProp = i.options.vertical === !0 ? 'top' : 'left', 'top' === i.positionProp ? i.$slider.addClass('slick-vertical') : i.$slider.removeClass('slick-vertical'), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ('number' == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = 'OTransform', i.transformType = '-o-transform', i.transitionType = 'OTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = 'MozTransform', i.transformType = '-moz-transform', i.transitionType = 'MozTransition', void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = 'webkitTransform', i.transformType = '-webkit-transform', i.transitionType = 'webkitTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = 'msTransform', i.transformType = '-ms-transform', i.transitionType = 'msTransition', void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = 'transform', i.transformType = 'transform', i.transitionType = 'transition'), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;

    if (t = n.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true'), n.$slides.eq(i).addClass('slick-current'), n.options.centerMode === !0) {
      var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass('slick-active').attr('aria-hidden', 'false') : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass('slick-active').attr('aria-hidden', 'false')), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass('slick-center') : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass('slick-center')), n.$slides.eq(i).addClass('slick-center');
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false') : t.length <= n.options.slidesToShow ? t.addClass('slick-active').attr('aria-hidden', 'false') : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass('slick-active').attr('aria-hidden', 'false') : t.slice(o, o + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false'));

    'ondemand' !== n.options.lazyLoad && 'anticipated' !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;

    if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t - s.slideCount).prependTo(s.$slideTrack).addClass('slick-cloned');
      }

      for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t + s.slideCount).appendTo(s.$slideTrack).addClass('slick-cloned');
      }

      s.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
        i(this).attr('id', '');
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is('.slick-slide') ? i(e.target) : i(e.target).parents('.slick-slide'),
        s = parseInt(o.attr('data-slick-index'));
    return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
    if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger('beforeChange', [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick('getSlick'), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
      a.postSlide(s);
    })) : a.postSlide(s), void a.animateHeight()) : void (t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function () {
      a.postSlide(s);
    }) : a.postSlide(s)));
  }, e.prototype.startLoad = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass('slick-loading');
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? 'left' : 'right' : o <= 360 && o >= 315 ? s.options.rtl === !1 ? 'left' : 'right' : o >= 135 && o <= 225 ? s.options.rtl === !1 ? 'right' : 'left' : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? 'down' : 'up' : 'vertical';
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;

    if (o.touchObject.edgeHit === !0 && o.$slider.trigger('edge', [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case 'left':
        case 'down':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }

      'vertical' != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger('swipe', [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(e.options.swipe === !1 || 'ontouchend' in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf('mouse') !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case 'start':
        e.swipeStart(i);
        break;

      case 'move':
        e.swipeMove(i);
        break;

      case 'end':
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && 'right' === t || l.currentSlide >= l.getDotCount() && 'left' === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;
    return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void (t.dragging = !0));
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i('.slick-cloned', e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger('unslick', [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i,
        e = this;
    i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), 0 === e.currentSlide ? (e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find('li').removeClass('slick-active').end(), i.$dots.find('li').eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass('slick-active'));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;

    for (i = 0; i < r; i++) {
      if ('object' == _typeof(s) || 'undefined' == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), 'undefined' != typeof t) return t;
    }

    return o;
  };
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../../impv/src/js/components/vimeo-modals-controller":11,"../../../impv/src/js/components/youtube-modals-controller":12,"./components/brighttalk-video":6,"./components/slick-with-indicator":7,"impv/src/js/components/dropdown-select":9,"impv/src/js/components/marketo-form":10}],9:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = require("events");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// auto focus on key press
var runOnce = 'impv_dropdown_auto_focus';

if (!(runOnce in window)) {
  $(function (_) {
    window[runOnce] = true;

    jQuery.expr[':'].startwith = function (a, i, m) {
      return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) == 0;
    };

    var timeout = null;
    var selectText = '';

    function clearSelect() {
      selectText = '';
    }

    $(document).on('keydown', '.impv-dropdown', function (event) {
      clearTimeout(timeout);
      /** clear the selected text after 1 sec */

      timeout = setTimeout(clearSelect, 1000);
      var container = $(event.currentTarget);

      var _char = String.fromCharCode(event.keyCode);

      selectText += _char;
      var selector = ".dropdown-item:visible:startwith('".concat(selectText, "')");
      $(selector, container).first().focus();
    });
  });
}

var DropDownSelect =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(DropDownSelect, _EventEmitter);

  _createClass(DropDownSelect, null, [{
    key: "register",
    value: function register(selector) {
      // register once
      if (global.DROP_DOWN_SLECT_GUARD_RUN_ONCE) {
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }

      selector = selector || '.dropdown.dropdown-select';

      if ($(selector).length > 0) {
        global.DROP_DOWN_SLECT_GUARD_RUN_ONCE = new DropDownSelect();
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }
    }
  }]);

  function DropDownSelect() {
    var _this;

    _classCallCheck(this, DropDownSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropDownSelect).call(this));

    _this.init();

    return _this;
  }

  _createClass(DropDownSelect, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      $('.impv-dropdown .dropdown-select-btn').on('click', function (e) {
        if ($(e.currentTarget).hasClass('no-options')) {
          e.preventDefault();
        } else {
          var currentBtn$ = $(e.currentTarget);
          var menuId = currentBtn$.attr('id');
          var value = currentBtn$.attr('data-value');

          if ($(document).width() <= 767) {
            setTimeout(function () {
              e.currentTarget.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
              });
            }, 10);
          }

          _this2.hideSelectedItem(menuId, value);
        }
      });
      $('.impv-dropdown .dropdown-item:not(.prev-def)').on('click', function (e) {
        e.preventDefault();
        var item$ = $(e.currentTarget);
        var parent$ = item$.parents('.dropdown-select');
        parent$.find('.dropdown-select-btn').attr('data-value', item$.attr('data-value')).attr('data-source', item$.attr('data-source')).find('.name').text(item$.text());
        parent$.trigger('select_changed', {
          parent$: parent$,
          item$: item$
        });

        _this2.emit('select_changed', parent$, item$);
      });
    }
  }, {
    key: "hideSelectedItem",
    value: function hideSelectedItem(menuId, value) {
      $(".impv-dropdown .dropdown-menu[aria-labelledby=\"".concat(menuId, "\"] .dropdown-item")).each(function (_, e) {
        e = $(e);

        if (e.attr('data-value') == value || e.hasClass('filtered')) {
          e.hide();
        } else {
          e.show();
        }
      });
    }
  }, {
    key: "chooseItem",
    value: function chooseItem(parentElem, dataSource) {
      $('.' + parentElem + ' .dropdown-item[data-source="' + dataSource + '"]').click();
    }
  }]);

  return DropDownSelect;
}(_events.EventEmitter);

exports["default"] = DropDownSelect;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"events":2}],10:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findById = exports.createForm = exports["default"] = void 0;

var _geoLocationService = require("impv/src/js/services/geo-location-service");

var _translateService = require("impv/src/js/services/translate-service");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isoCountries = {
  af: 'afghanistan',
  ax: 'aland islands',
  al: 'albania',
  dz: 'algeria',
  as: 'american samoa',
  ad: 'andorra',
  ao: 'angola',
  ai: 'anguilla',
  aq: 'antarctica',
  ag: 'antigua and barbuda',
  ar: 'argentina',
  am: 'armenia',
  aw: 'aruba',
  asc: 'ascension island',
  au: 'australia',
  at: 'austria',
  az: 'azerbaijan',
  bs: 'bahamas',
  bh: 'bahrain',
  bd: 'bangladesh',
  bb: 'barbados',
  by: 'belarus',
  be: 'belgium',
  bz: 'belize',
  bj: 'benin',
  bm: 'bermuda',
  bt: 'bhutan',
  bo: 'bolivia',
  bq: 'bonaire',
  ba: 'bosnia and herzegovina',
  bw: 'botswana',
  bv: 'bouvet island',
  br: 'brazil',
  io: 'british indian ocean territory',
  bn: 'brunei darussalam',
  bg: 'bulgaria',
  bf: 'burkina faso',
  bi: 'burundi',
  kh: 'cambodia',
  cm: 'cameroon',
  ca: 'canada',
  cv: 'cape verde',
  ky: 'cayman islands',
  cf: 'central african republic',
  td: 'chad',
  cl: 'chile',
  cn: 'china',
  cx: 'christmas island',
  cc: 'cocos (keeling) islands',
  co: 'colombia',
  km: 'comoros',
  cg: 'congo',
  cd: 'congo, dem. rep. of the',
  ck: 'cook islands',
  cr: 'costa rica',
  ci: 'ivory coast',
  hr: 'croatia',
  cu: 'cuba',
  cuw: 'curacao',
  cy: 'cyprus',
  cz: 'czech republic',
  dk: 'denmark',
  dj: 'djibouti',
  dm: 'dominica',
  "do": 'dominican republic',
  ec: 'ecuador',
  eg: 'egypt',
  sv: 'el salvador',
  gq: 'equatorial guinea',
  er: 'eritrea',
  ee: 'estonia',
  et: 'ethiopia',
  fk: 'falkland islands (malvinas)',
  fo: 'faroe islands',
  fj: 'fiji',
  fi: 'finland',
  fr: 'france',
  gf: 'french guiana',
  pf: 'french polynesia',
  tf: 'french southern territories',
  ga: 'gabon',
  gm: 'gambia',
  ge: 'georgia',
  de: 'germany',
  gh: 'ghana',
  gi: 'gibraltar',
  gr: 'greece',
  gl: 'greenland',
  gd: 'grenada',
  gp: 'guadeloupe',
  gu: 'guam',
  gt: 'guatemala',
  gg: 'guernsey',
  gn: 'guinea',
  gw: 'guinea-bissau',
  gy: 'guyana',
  ht: 'haiti',
  hm: 'heard island & mcdonald islands',
  va: 'holy see (vatican city state)',
  hn: 'honduras',
  hk: 'hong kong',
  hu: 'hungary',
  is: 'iceland',
  "in": 'india',
  id: 'indonesia',
  ir: 'iran, islamic republic of',
  iq: 'iraq',
  ie: 'ireland',
  im: 'isle of man',
  il: 'israel',
  it: 'italy',
  jm: 'jamaica',
  jp: 'japan',
  je: 'jersey',
  jo: 'jordan',
  kz: 'kazakhstan',
  ke: 'kenya',
  ki: 'kiribati',
  xk: 'kosovo',
  kw: 'kuwait',
  kg: 'kyrgyzstan',
  la: 'lao',
  lv: 'latvia',
  lb: 'lebanon',
  ls: 'lesotho',
  lr: 'liberia',
  ly: 'libyan arab jamahiriya',
  li: 'liechtenstein',
  lt: 'lithuania',
  lu: 'luxembourg',
  mo: 'macao',
  mk: 'macedonia',
  mg: 'madagascar',
  mw: 'malawi',
  my: 'malaysia',
  mv: 'maldives',
  ml: 'mali',
  mt: 'malta',
  mh: 'marshall islands',
  mq: 'martinique',
  mr: 'mauritania',
  mu: 'mauritius',
  yt: 'mayotte',
  mx: 'mexico',
  fm: 'micronesia, federated states of',
  md: 'moldova',
  mc: 'monaco',
  mn: 'mongolia',
  me: 'montenegro',
  ms: 'montserrat',
  ma: 'morocco',
  mz: 'mozambique',
  mm: 'myanmar',
  na: 'namibia',
  nr: 'nauru',
  np: 'nepal',
  nl: 'netherlands',
  an: 'netherlands antilles',
  nc: 'new caledonia',
  nz: 'new zealand',
  ni: 'nicaragua',
  ne: 'niger',
  ng: 'nigeria',
  nu: 'niue',
  nf: 'norfolk island',
  kr: 'north norea',
  mp: 'northern mariana islands',
  no: 'norway',
  om: 'oman',
  pk: 'pakistan',
  pw: 'palau',
  ps: 'palestinian territory',
  pa: 'panama',
  pg: 'papua new guinea',
  py: 'paraguay',
  pe: 'peru',
  ph: 'philippines',
  pn: 'pitcairn',
  pl: 'poland',
  pt: 'portugal',
  pr: 'puerto rico',
  qa: 'qatar',
  re: 'reunion',
  ro: 'romania',
  ru: 'russian federation',
  rw: 'rwanda',
  bl: 'saint barthelemy',
  sh: 'saint helena',
  kn: 'saint kitts and nevis',
  lc: 'saint lucia',
  mf: 'saint martin',
  pm: 'saint pierre and miquelon',
  vc: 'saint vincent and grenadines',
  ws: 'samoa',
  sm: 'san marino',
  st: 'sao tome and principe',
  sa: 'saudi arabia',
  sn: 'senegal',
  rs: 'serbia',
  sc: 'seychelles',
  sl: 'sierra leone',
  sg: 'singapore',
  sx: 'sint maartin (dutch part)',
  sk: 'slovakia',
  si: 'slovenia',
  sb: 'solomon islands',
  so: 'somalia',
  za: 'south africa',
  gs: 'south georgia and sandwich islands',
  kp: 'south korea',
  sd: 'sudan',
  es: 'spain',
  lk: 'sri lanka',
  sr: 'suriname',
  sj: 'svalbard and jan mayen',
  sz: 'swaziland',
  se: 'sweden',
  ch: 'switzerland',
  sy: 'syrian arab republic',
  tw: 'taiwan',
  tj: 'tajikistan',
  tz: 'tanzania',
  th: 'thailand',
  tl: 'timor-leste',
  tg: 'togo',
  tk: 'tokelau',
  to: 'tonga',
  tt: 'trinidad and tobago',
  tn: 'tunisia',
  tr: 'turkey',
  tm: 'turkmenistan',
  tc: 'turks and caicos islands',
  tv: 'tuvalu',
  ug: 'uganda',
  ua: 'ukraine',
  ae: 'united arab emirates',
  gb: 'united kingdom',
  us: 'united states',
  um: 'united states minor outlying islands',
  uy: 'uruguay',
  uz: 'uzbekistan',
  vu: 'vanuatu',
  ve: 'venezuela',
  vn: 'vietnam',
  vg: 'virgin islands, british',
  vi: 'virgin islands, u.s.',
  wf: 'wallis and futuna',
  eh: 'western sahara',
  ye: 'yemen',
  zm: 'zambia',
  zw: 'zimbabwe'
};
var emails = ['gamil.com', 'gmail.co', 'gmail.org', 'gmail.com', 'aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmx.com', 'googlemail.com', 'google.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'mail.com', 'msn.com', 'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk', 'email.com', 'fastmail.fm', 'games.com ', 'gmx.net', 'hush.com', 'hushmail.com', 'icloud.com', 'iname.com', 'inbox.com', 'lavabit.com', 'love.com ', 'outlook.com', 'pobox.com', 'protonmail.ch', 'protonmail.com', 'tutanota.de', 'tutanota.com', 'tutamail.com', 'tuta.io', 'keemail.me', 'rocketmail.com ', 'safe-mail.net', 'wow.com ', 'ygm.com ', 'ymail.com ', 'zoho.com', 'yandex.com', 'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com', 'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk', 'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk', 'virgin.net', 'wanadoo.co.uk', 'bt.com', 'sina.com', 'sina.cn', 'qq.com', 'naver.com', 'hanmail.net', 'daum.net', 'nate.com', 'yahoo.co.jp', 'yahoo.co.kr', 'yahoo.co.id', 'yahoo.co.in', 'yahoo.com.sg', 'yahoo.com.ph', '163.com', 'yeah.net', '126.com', '21cn.com', 'aliyun.com', 'foxmail.com', 'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr', 'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de ', 'web.de', 'yahoo.de', 'libero.it', 'virgilio.it', 'hotmail.it', 'aol.it', 'tiscali.it', 'alice.it', 'live.it', 'yahoo.it', 'email.it', 'tin.it', 'poste.it', 'teletu.it', 'mail.ru', 'rambler.ru', 'yandex.ru', 'ya.ru', 'list.ru', 'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be', 'telenet.be', 'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar', 'yahoo.com.mx', 'live.com.mx', 'hotmail.es', 'hotmail.com.mx', 'prodigy.net.mx', 'yahoo.ca', 'hotmail.ca', 'bell.net', 'shaw.ca', 'sympatico.ca', 'rogers.com', 'yahoo.com.br', 'hotmail.com.br', 'outlook.com.br', 'uol.com.br', 'bol.com.br', 'terra.com.br', 'ig.com.br', 'itelefonica.com.br', 'r7.com', 'zipmail.com.br', 'globo.com', 'globomail.com', 'oi.com.br'];

var getCountryCodeFromName = function getCountryCodeFromName(countryName) {
  return Object.keys(isoCountries).find(function (key) {
    return isoCountries[key] === countryName;
  });
}; // TODO: move the setting to marketo config file


var MARKETO_SERVER_URL = '//go.imperva.com';
var MARKETO_APP_KEY = '727-WRL-406';
var marketoForms = global.marketoForms = global.marketoForms || {};
var siteUrl = location.protocol + '//' + location.host;

var MarketoForm =
/*#__PURE__*/
function () {
  function MarketoForm(formId) {
    var formArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var elem = arguments.length > 2 ? arguments[2] : undefined;
    var runNextFormFn = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, MarketoForm);

    this.uuid = formArgs.uuid || parseInt(Math.random() * 10000);
    this.uniqueIdPostfix = '_' + this.uuid;
    this.formId = formId;
    this.formArgs = formArgs;
    this.runNextFormFn = runNextFormFn;
    this.cbs = [];
    this.onSubmitCbs = [];
    this.onValidateCbs = [];
    this.pressOnEnterTimer = null;
    this.clickOnSubmitTimer = null;
    this.keyEnterPressed = false;
    this.submitBtnClicked = false;
    this.elem = elem;
    this.buttonText = this.getFormElem(this.form).find('.mktoButtonWrap button[type="submit"]').text();

    if (!this.elem) {
      console.error('MarketoForm:constructor missing elem param for form ID ', this.formId);
    }

    this.modifyElementsId();
    this.setupMarketoForm(formArgs);
    this.createForm();
    this.sendValidate();
    this.sendSubmit();
  }

  _createClass(MarketoForm, [{
    key: "createForm",
    value: function () {
      var _createForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.elem) {
                  $(this.elem).attr('id', "mktoForm_".concat(this.formId));
                }

                try {
                  if ('MktoForms2' in window) {
                    MktoForms2.loadForm(MARKETO_SERVER_URL, MARKETO_APP_KEY, this.formId, function (form) {
                      _this.form = form;
                      _this.formElem = _this.getFormElem(form);

                      _this.formElem.attr('id', '');

                      _this.formElem.addClass('mkto-loaded');

                      _this.isHtmlTemplate = $('.mktoTemplateBox', _this.formElem).length > 0;

                      if (_this.isHtmlTemplate) {
                        _this.setHtmlTemplate();
                      }

                      _this.fireEvent();

                      if (typeof _this.runNextFormFn === 'function') {
                        _this.runNextFormFn();
                      }

                      var formLoadedEvt = new CustomEvent('mktoFormLoaded', {
                        detail: _this.formElem.attr('data-form-id')
                      });

                      if ($(_this.formElem).length) {
                        $(_this.formElem)[0].dispatchEvent(formLoadedEvt);
                      }
                    }); // console.log(`register MktoForm id ${this.formId}`);
                  } else {
                    console.error('MktoForms2 is not define');
                  }
                } catch (error) {
                  console.error('Error in class MarketoForm', error);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createForm() {
        return _createForm.apply(this, arguments);
      }

      return createForm;
    }()
  }, {
    key: "snapShotValidation",
    value: function snapShotValidation() {
      var _this2 = this;

      this.onSuccess(function (form) {
        var dataToSend = {};
        var formElem = $(form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this2.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['name'] = (formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        dataToSend['telephone'] = formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['email'] = formElem.find("#Email".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['state'] = formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['jobTitle'] = formElem.find("#Title".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['company'] = formElem.find("#Company".concat(_this2.uniqueIdPostfix)).val();
        var eULAConsent = formElem.find($("[name=\"eULAConsent\"]"));
        dataToSend['eULAConsent'] = eULAConsent.prop('checked');
        dataToSend['eULAConsent_copy'] = eULAConsent.next().html();
        var countryInput = formElem.find("#Country".concat(_this2.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        dataToSend['country'] = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        $.ajax({
          type: 'POST',
          url: siteUrl + '/wp-json/imperva_snapshot/v1/register/',
          data: dataToSend,
          async: false,
          dataType: 'json',
          success: function success(data) {
            var response = $.parseJSON(data);

            if (response[0].includes('200')) {
              window.location.assign('/resources/snapshot-thank-you/');
            } else {
              window.location.assign('/resources/snapshot-problem/');
            }
          },
          error: function error() {
            window.location.assign('/resources/snapshot-problem/');
          }
        });
        return false;
      });
    }
  }, {
    key: "modifyElementsId",
    value: function modifyElementsId() {
      var _this3 = this;

      this.onLoad(function (form) {
        var formElem = _this3.getFormElem(form);

        if (formElem.length) {
          var fields = formElem.find('input, select, textarea');
          var labels = formElem.find('label');
          fields.each(function (i, el) {
            var $el = $(el);
            var id = $el.attr('id');

            if (id) {
              $el.attr('id', id + _this3.uniqueIdPostfix);
            }
          });
          labels.each(function (i, el) {
            var $el = $(el);
            var labelFor = $el.attr('for');

            if (labelFor) {
              $el.attr('for', labelFor + _this3.uniqueIdPostfix);
            }
          });
        }
      });
    }
  }, {
    key: "eCustomsValidation",
    value: function eCustomsValidation() {
      var _this4 = this;

      var thankYouUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.onSubmit(function (_form) {
        var formElem = $(_form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this4.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this4.uniqueIdPostfix)).val();

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (FirstName.includes(' ') || FirstName.includes('test'))) {
          _form.setErrorMessage('FirstName', 'please enter a valid name');

          return false;
        }

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (LastName.includes(' ') || LastName.includes('test'))) {
          _form.setErrorMessage('LastName', 'please enter a valid name');

          return false;
        }

        var fullName = (formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        var Phone = formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val().split('-').join('') : '';
        var Email = formElem.find("#Email".concat(_this4.uniqueIdPostfix)).val();
        var State = formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() : '';
        var Title = formElem.find("#Title".concat(_this4.uniqueIdPostfix)).val();
        var Company = formElem.find("#Company".concat(_this4.uniqueIdPostfix)).val().replace(' ', '%20');
        var countryInput = formElem.find("#Country".concat(_this4.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        var Country = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        var url = siteUrl + "/wp-json/ecustoms_screening/v1/formID/".concat(_this4.formId, "?email=").concat(Email, "&name=").concat(fullName, "&telephone=").concat(Phone, "&jobTitle=").concat(Title, "&country=").concat(Country).concat(State, "&company=").concat(Company);
        var approve = false;
        var locationAssign = false;
        $.ajax({
          url: url,
          async: false,
          dataType: 'json',
          success: function success(response) {
            if (response != null && response.approved) {
              approve = true;

              if (thankYouUrl != null) {
                locationAssign = thankYouUrl;
              }
            } else {
              if (response === null) {
                console.log('eCustoms not available');
              }

              locationAssign = '/resources/free-tools-thank-you/';
              approve = false;
            }
          }
        });
        _this4.location_assign = locationAssign;
        return approve;
      });
    }
  }, {
    key: "fireEvent",
    value: function fireEvent() {
      var _this5 = this;

      if (this.cbs) {
        this.cbs.forEach(function (cb) {
          return cb(_this5.form);
        });
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad(cb) {
      if (typeof cb === 'function') {
        if (this.form) {
          cb(this.form);
        } else {
          if (!this.cbs) {
            this.cbs = [];
          }

          this.cbs.push(cb);
        }
      }

      return this;
    }
    /**
     * register for input/s events
     * @param {string} eventNames
     * the events name to register
     * cab be multy event etc. 'change, input'
     * @param {string|function} inputName
     * if inputName is string ==> register for specific input | Else: if inputName is function => register for all inputs
     * @param {?function} cb
     * the callback function for this events
     * @return {MarketoForm} to chaining functions
     */

  }, {
    key: "registerEvent",
    value: function registerEvent(eventNames, inputName, cb) {
      var _this6 = this;

      if (typeof inputName === 'function') {
        cb = inputName;
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              $(formElem).on(eventName, "input, textarea, select", cb);
            });
          }
        });
      } else if (inputName && typeof cb === 'function') {
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              // console.log(
              //   `register event ${eventName} to elem ${inputName}`,
              //   $(`input[name="${inputName}"], textarea[name="${inputName}"], select[name="${inputName}"]`, formElem).data('events')
              // );
              $(formElem).on(eventName, "input[name=\"".concat(inputName, "\"], textarea[name=\"").concat(inputName, "\"], select[name=\"").concat(inputName, "\"]"), cb);
            });
          }
        });
      }

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(cb) {
      var _this7 = this;

      if (typeof cb === 'function') {
        this.onLoad(function (form) {
          return form.onSuccess(function (values, followUpUrl) {
            var form_block = document.querySelector('.form-block');
            var form_wrap = document.querySelector('.form-section .form-wrapper');

            if (form_wrap && form_wrap.classList.contains('form-block-class')) {
              form_block.classList.add('form-block-success');
            }

            return cb(_this7, values, followUpUrl);
          });
        });
      }

      return this;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(cb) {
      if (typeof cb === 'function') {
        this.onSubmitCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendSubmit",
    value: function sendSubmit() {
      var _this8 = this;

      this.onLoad(function (form) {
        return form.onSubmit(function (nativeValid) {
          var originalText = _this8.getButtonText(form);

          _this8.changeButtonText('Please wait', form);

          _this8.setButtonDisabled(form);

          var approvalsSubmit = [];

          _this8.onSubmitCbs.forEach(function (cb) {
            approvalsSubmit.push(cb(_this8));
          });

          if (!approvalsSubmit.includes(false) && nativeValid) {
            form.submittable(true);

            if (_this8.location_assign) {
              window.location.assign(_this8.location_assign);
            }

            return true;
          }

          _this8.changeButtonText(originalText, form);

          _this8.setButtonEnable(form);

          form.submittable(false);

          if (_this8.location_assign) {
            window.location.assign(_this8.location_assign);
          }

          return false;
        });
      });
    }
  }, {
    key: "onValidate",
    value: function onValidate(cb) {
      if (typeof cb === 'function') {
        this.onValidateCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendValidate",
    value: function sendValidate() {
      var _this9 = this;

      this.onLoad(function (form) {
        return form.onValidate(function (nativeValid) {
          var approvalsValidate = [];

          _this9.onValidateCbs.forEach(function (cb) {
            approvalsValidate.push(cb(_this9));
          });

          if (!approvalsValidate.includes(false) && nativeValid) {
            form.submittable(true);
            return true;
          }

          form.submittable(false);
          return false;
        });
      });
    }
  }, {
    key: "setButtonText",
    value: function setButtonText(text) {
      var _this10 = this;

      this.onLoad(function (form) {
        return _this10.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').text(text);
      });
      return this;
    }
  }, {
    key: "setButtonDisabled",
    value: function setButtonDisabled(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('disabled', true);
    }
  }, {
    key: "setButtonEnable",
    value: function setButtonEnable(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeAttr('disabled');
    }
  }, {
    key: "changeButtonText",
    value: function changeButtonText(text, form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html(text);
    }
  }, {
    key: "getButtonText",
    value: function getButtonText(form) {
      return this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html();
    }
  }, {
    key: "setButtonClasses",
    value: function setButtonClasses(classes) {
      var _this11 = this;

      if (classes) {
        this.onLoad(function (form) {
          return _this11.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeClass('mktoButton').addClass(classes);
        });
      }

      return this;
    }
  }, {
    key: "setButtonEvents",
    value: function setButtonEvents(events) {
      var _this12 = this;

      if (events) {
        this.onLoad(function (form) {
          Object.entries(events).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            console.log(value);

            _this12.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr(key, value);
          });
        });
      }

      return this;
    }
  }, {
    key: "setButtonTarget",
    value: function setButtonTarget(target) {
      var _this13 = this;

      if (target) {
        this.onLoad(function (form) {
          return _this13.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('target', target);
        });
      }

      return this;
    }
  }, {
    key: "setValues",
    value: function setValues(values, cbFn) {
      this.onLoad(function (form) {
        form.setValues(values);

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "hasOption",
    value: function hasOption(name, value) {
      var formElem = this.formElem;
      if (!formElem) return false;
      var option = formElem.find("[name=\"".concat(name, "\"] option[value=\"").concat(value, "\"]"));
      return option.length > 0;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(field, value) {
      field.val(value);
    }
  }, {
    key: "setValue",
    value: function setValue(name, value, cbFn) {
      var _this14 = this;

      this.onLoad(function (form) {
        try {
          form.setValues(_defineProperty({}, name, value));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Faild to set form field value', {
            field: name,
            value: value
          });
        }

        var formElem = _this14.getFormElem(form);

        var input = $("[name=\"".concat(name, "\"]"), formElem);

        if (input && input.is('select')) {
          var option = input.find("option[value=\"".concat(value, "\"]"));

          if (option.length > 0) {
            option.attr('selected', 'selected');
          }
        }

        if (input && input.is(':visible')) {
          // fire change and blur event to trigger the validations
          input.change();
          input.blur();
        }

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "setThankyouText",
    value: function setThankyouText(html) {
      var _this15 = this;

      if (html) {
        this.onSuccess(function () {
          var formElem = _this15.getFormElem();

          $(formElem).hide();
          var thankyouDiv = "\n          <div id=\"marketo_form_thankyou_".concat(_this15.formId, "\" class=\"marketo-form-thankyou-message\">\n            ").concat(html, "\n          </div>\n        ");
          $(formElem).parent().append(thankyouDiv);
          return false;
        });
      }
    }
  }, {
    key: "setThankyouUrl",
    value: function setThankyouUrl(url) {
      if (url) {
        this.onSuccess(function () {
          window.location.assign(url);
          return false;
        });
      }

      return this;
    }
  }, {
    key: "getFormElem",
    value: function getFormElem(form) {
      if (this.elem) {
        return $(this.elem);
      } else if (form) {
        return form.getFormElem();
      } else if (this.form) {
        return this.form.getFormElem();
      }

      return null;
    }
  }, {
    key: "getField",
    value: function getField(name) {
      var _this16 = this;

      return new Promise(function (resolve) {
        _this16.onLoad(function (form) {
          var formElem = _this16.getFormElem(form);

          var input = $("[name=\"".concat(name, "\"]"), formElem);
          resolve(input);
        });
      });
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      var _this17 = this;

      return new Promise(function (resolve) {
        _this17.getValues().then(function (vals) {
          resolve(vals[name]);
        });
      });
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this18 = this;

      return new Promise(function (resolve) {
        _this18.onLoad(function (form) {
          resolve(form.getValues());
        });
      });
    }
  }, {
    key: "setLables",
    value: function setLables(lables) {
      var _this19 = this;

      var keys = Object.keys(lables);
      keys.forEach(function (key) {
        _this19.setLable(key, lables[key]);
      });
      return this;
    }
  }, {
    key: "setAutoLables",
    value: function setAutoLables() {
      var _this20 = this;

      this.onLoad(function (form) {
        var formElem = _this20.getFormElem(form);

        var inputs = $("[name]", formElem);
        var labels = {};
        inputs && inputs.each(function (_, el) {
          if ($(el).prop('nodeName') !== 'SELECT' && $(el).attr('type') !== 'checkbox' && $(el).attr('autoLables') !== 'false') {
            var name = $(el).attr('name');
            var id = $(el).attr('id');
            var placeholder = $(el).attr('placeholder');
            var label = placeholder || name;

            if (id && label) {
              labels[id] = label;
              $(el).attr('placeholder', label === 'FirstName' ? 'First name' : label === 'LastName' ? 'Last name' : label);
            }
          }
        });

        if (labels) {
          _this20.setLables(labels);
        }
      });
      return this;
    }
  }, {
    key: "setLable",
    value: function setLable(id, text) {
      var _this21 = this;

      this.onLoad(function (form) {
        var formElem = _this21.getFormElem(form);

        var label = $("label[for=\"".concat(id, "\"]"), formElem);
        label.text(text);
      });
      return this;
    }
  }, {
    key: "hideField",
    value: function hideField(name, duration) {
      var _this22 = this;

      this.onLoad(function (form) {
        var formElem = _this22.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.hide(duration);
        }
      });
      return this;
    }
  }, {
    key: "hasField",
    value: function hasField(name) {
      return this.getField(name).then(function (input) {
        return input.length > 0;
      });
    }
  }, {
    key: "showField",
    value: function showField(name, duration) {
      var _this23 = this;

      this.onLoad(function (form) {
        var formElem = _this23.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.show(duration);
        }
      });
      return this;
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(fieldName, error) {
      var _this24 = this;

      var scrollTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.onLoad(function (form) {
        var formElem = _this24.getFormElem(form);

        var input = $("[name=\"".concat(fieldName, "\"]"), formElem);
        var field = $(input).parents('.mktoFieldWrap:first');

        if (error) {
          input.removeClass('mktoValid');
          input.addClass('mktoInvalid');
          input.siblings('.mktoError').show();
          field.addClass('mktoInvalidField');
        } else {
          input.removeClass('mktoInvalid');
          field.removeClass('mktoInvalidField');
        }

        form.submittable(false);
        form.showErrorMessage(error, input ? MktoForms2.$(input.get(0)) : null); // scroll into invalid input

        if (scrollTo && !_this24.formArgs['doNotScrollOnError']) {
          var top = $(formElem).offset().top;
          var notInModal = !formElem.closest('.modal').length;

          if (notInModal) {
            var header = $('#header');
            top -= header.outerHeight();
            window.scroll({
              top: top,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      });
      return this;
    }
    /**
     * split the full name to Firstname and LastName
     * @param {string} fullName fullname input value
     * @return {{firstName, lastName}} splitedFullName
     */

  }, {
    key: "splitFullName",
    value: function splitFullName(fullName) {
      /**
       * capitalize all word in given line
       * @param {string} text
       * the line text will be capitalize
       * @example
       * input: "shalom s. tuby"
       * output: "Shalom S. Tuby"
       * @return {string} capitalize all word in given line
       */
      var capitalize = function capitalize(text) {
        return text.toLowerCase().split(' ').map(function (s) {
          return s.charAt(0).toUpperCase() + s.substring(1);
        }).join(' ');
      };

      fullName = fullName.trim();

      if (!fullName) {
        return {};
      } // remove duplicate spaces


      fullName = fullName.replace(/\s{2,}/g, ' ');
      var split = '';

      if (fullName.includes('　')) {
        split = fullName.split('　');
      } else {
        split = fullName.split(' ');
      }

      if (split.length) {
        var firstName = split[0];
        var lastName = split[1] ? split.slice(1).join(' ') : '';
        firstName = capitalize(firstName);
        lastName = capitalize(lastName);
        return {
          firstName: firstName,
          lastName: lastName
        };
      }

      return {};
    }
  }, {
    key: "sendEventOnNoCountry",
    value: function sendEventOnNoCountry() {
      var dataLayerToSend = {
        event: 'GAevent',
        eventCategory: 'country field',
        eventAction: 'view',
        eventLabel: 'request demo form'
      };

      if (!global.dataLayer) {
        global.dataLayer = [];
      }

      global.dataLayer.push(dataLayerToSend);
    }
  }, {
    key: "prePopulatedCountry",
    value: function prePopulatedCountry() {
      var _this25 = this;

      // console.log('prePopulatedCountry for ', this.formId);
      this.hideField('Country').registerEvent('change', 'Country', function (event) {
        var inputElem = $(event.target);
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          _this25.setLable('State', 'State');

          _this25.getField('State').then(function (input) {
            var parent = $(input).parents('.mktoFieldWrap:first');
            var inputType = 'select';
            parent.addClass("inputType_".concat(inputType));
          });
        }
      }); // initial country and state from geo service

      (0, _geoLocationService.getGeoLocationData)().then(function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            state = _ref3.state,
            error = _ref3.error,
            status = _ref3.status,
            country = _ref3.country,
            stateCode = _ref3.stateCode,
            postalcode = _ref3.postalcode;

        // console.log('set GEO location for ', this.formId);
        if (!error && status == _geoLocationService.FINISH_STATUS && country) {
          _this25.onLoad(function () {
            // do not trigger auto Country if the form is in HtmlTemplate mode
            if (_this25.isHtmlTemplate) return; // set the country field from the GEO service

            if (country) {
              if (_this25.hasOption('Country', country)) {
                _this25.setValue('Country', country, function () {
                  _this25.hideField('Country');

                  if (_this25.formElem.find("[name=\"State\"]").length > 0) {
                    if (stateCode || state) {
                      if (_this25.hasOption('State', stateCode)) {
                        _this25.setValue('State', stateCode, function () {
                          return _this25.hideField('State');
                        });
                      } else if (_this25.hasOption('State', state)) {
                        _this25.setValue('State', state, function () {
                          return _this25.hideField('State');
                        });
                      } else {
                        _this25.showField('State');

                        _this25.showField('Country');

                        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


                        console.error('Failed to set State from GeoLocation service');
                      }
                    }
                  }
                });
              } else {
                _this25.sendEventOnNoCountry();

                _this25.showField('Country'); // eslint-disable-next-line no-console


                console.error('Failed to set Country from GeoLocation service');
              }
            } // set the postal_code field from the GEO service


            if (postalcode && postalcode != '0000') {
              _this25.setValue('PostalCode', postalcode);
            }
          });
        } else {
          _this25.sendEventOnNoCountry();

          _this25.showField('Country');

          console.error('Failed to set Country from GeoLocation service');
        }
      }, function (err) {
        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


        console.error('Failed to get country from GeoLocation Service', err);

        _this25.showField('Country');
      });
    }
  }, {
    key: "setHiddenFields",
    value: function setHiddenFields(hiddenFields) {
      var _this26 = this;

      if (hiddenFields) {
        $.each(hiddenFields, function (key, value) {
          var currentKey = key == 'form_type' ? 'formType' : key;

          _this26.setValue(currentKey, value);
        });
      }
    }
  }, {
    key: "setupMarketoForm",
    value: function setupMarketoForm(args) {
      var _this27 = this;

      //add support for error messages translation, get error messages from global var with translations if it exist
      var full_name_error_message = '';
      var email_error = 'Must be valid email. example@yourdomain.com';
      var phone_error = 'Must be a phone number. 503-555-1212';
      var company_error = 'This field is required.';
      var title_error = 'This field is required.';
      var department_error = 'This field is required.';
      var mobilephone_error = 'Must be a phone number. 503-555-1212';
      var firstname_error = 'This field is required.';
      var lastname_error = 'This field is required.';

      if (typeof error_messages !== 'undefined') {
        full_name_error_message = error_messages.full_name_error_message !== undefined ? error_messages.full_name_error_message : '';
        email_error = error_messages.email_error;
        phone_error = error_messages.phone_error;
        company_error = error_messages.company_error;
        title_error = error_messages.title_error;
        department_error = error_messages.department_error;
        mobilephone_error = error_messages.mobilephone_error;
        firstname_error = error_messages.firstname_error;
        lastname_error = error_messages.lastname_error;
      }

      var FullNameErrorMessage = full_name_error_message ? full_name_error_message : (0, _translateService.translate)('marketo_form.full_name_error_message', 'First Name and Last Name required');

      if (!args['no_auto_label']) {
        this.setAutoLables();
      }

      if (args['pre_populated_country']) {
        this.prePopulatedCountry();
      }

      if (args['button_label']) {
        this.setButtonText(args['button_label']);
      }

      if (args['button_class']) {
        this.setButtonClasses(args['button_class']);
      }

      if (args['button_events']) {
        this.setButtonEvents(args['button_events']);
      }

      if (args['thankyou_url']) {
        this.thankyouPageUrl = args['thankyou_url'];
        this.setThankyouUrl(args['thankyou_url']);
      }

      if (args['hidden_fields']) {
        this.setHiddenFields(args['hidden_fields']);
      }

      if (args['validate_fullname']) {
        this.registerEvent('input', 'fullNameTrendemon', function (event) {
          var fullName = event.target.value;

          var _this27$splitFullName = _this27.splitFullName(fullName),
              firstName = _this27$splitFullName.firstName,
              lastName = _this27$splitFullName.lastName;

          _this27.setValue('FirstName', firstName);

          _this27.setValue('LastName', lastName);
        });
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).registerEvent('blur', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(event) {
            var inputElem, parent, lastNameElem, lastName;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context2.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    _context2.next = 6;
                    return _this27.getField('LastName');

                  case 6:
                    lastNameElem = _context2.sent;
                    lastName = lastNameElem.val();

                    if (!lastName) {
                      setTimeout(function () {
                        inputElem.addClass('mktoInvalid');
                        inputElem.removeClass('mktoValid');
                        parent.addClass('mktoInvalidField');

                        _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
                      }, 0);
                    } else {
                      setTimeout(function () {
                        inputElem.removeClass('mktoInvalid');
                        parent.removeClass('mktoInvalidField');
                      }, 0);
                    }

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }()).registerEvent('focusin', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(event) {
            var inputElem, parent;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context3.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    inputElem.removeClass('mktoInvalid');
                    parent.removeClass('mktoInvalidField'); //support error messages translation

                    if (typeof error_messages !== 'undefined') {
                      _this27.onLoad(function (form) {
                        form.showErrorMessage(FullNameErrorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                      });
                    }

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref5.apply(this, arguments);
          };
        }());
      }

      if (args['validate_private_email_domain']) {
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).registerEvent('blur', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4() {
          var inputElem, email, emailDomain;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context4.sent;
                  email = inputElem.val().toLowerCase();
                  emailDomain = email.split('@');

                  if ($.inArray(emailDomain[1], emails) !== -1) {
                    setTimeout(function () {
                      inputElem.addClass('mktoInvalid');
                      inputElem.removeClass('mktoValid');

                      _this27.setErrorMessage('Email', args['email_domain_error'], false);
                    }, 0);
                  } else {
                    setTimeout(function () {
                      inputElem.removeClass('mktoInvalid');
                    }, 0);
                  }

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))).registerEvent('focusin', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5() {
          var inputElem;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context5.sent;
                  inputElem.removeClass('mktoInvalid');

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })));
      }

      var validateNotEmpty = function validateNotEmpty(str) {
        return str.length;
      };

      var validateEmail = function validateEmail(str) {
        var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return re.test(String(str).toLowerCase());
      };

      var validateNum = function validateNum(str) {
        return validateNotEmpty(str) && /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/.test(str);
      };

      var getValidatorByName = function getValidatorByName(name) {
        var meta = {
          Email: validateEmail,
          Phone: validateNum,
          Company: validateNotEmpty,
          Title: validateNotEmpty,
          MobilePhone: validateNum
        };
        return meta[name] || validateNotEmpty;
      };

      var inputsOnBlur = function inputsOnBlur(e, errorMessage) {
        var inputElem = jQuery(e.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();
        var validatorFn = getValidatorByName(inputElem.attr('name'));

        if (!validatorFn(val)) {
          setTimeout(function () {
            inputElem.addClass('mktoInvalid');
            inputElem.removeClass('mktoValid');
            parent.addClass('mktoInvalidField');

            _this27.setErrorMessage(inputElem.attr('name'), errorMessage, false);
          }, 0);
        } else {
          setTimeout(function () {
            inputElem.removeClass('mktoInvalid');
            parent.removeClass('mktoInvalidField');
          }, 0);
        }
      };

      var inputsOnFoucsIn =
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(e, errorMessage) {
          var inputElem, parent;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  inputElem = jQuery(e.target);
                  parent = inputElem.parents('.mktoFieldWrap:first');
                  inputElem.removeClass('mktoInvalid');
                  parent.removeClass('mktoInvalidField'); //support error messages translation

                  if (typeof error_messages !== 'undefined') {
                    _this27.onLoad(function (form) {
                      form.showErrorMessage(errorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                    });
                  }

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function inputsOnFoucsIn(_x3, _x4) {
          return _ref8.apply(this, arguments);
        };
      }();

      var inputsOnSubmit = function inputsOnSubmit(name, form, errorMessage) {
        if (typeof error_messages !== 'undefined') {
          var input = $("[name=\"".concat(name, "\"]"), form);
          var parent = input.parent();

          if (parent.hasClass('mktoFieldTouched') && parent.hasClass('mktoInvalidField')) {
            _this27.setErrorMessage(name, errorMessage, false);
          }
        }

        return true;
      };

      [['Email', args['email_invalid_error'] !== '' ? args['email_invalid_error'] : email_error], ['Phone', phone_error], ['Company', company_error], ['Title', title_error], ['Department', department_error], ['MobilePhone', mobilephone_error], ['FirstName', firstname_error], ['LastName', lastname_error]].forEach(function (field) {
        var name = field[0];
        var msg = field[1];

        _this27.registerEvent('blur', name, function (e) {
          inputsOnBlur(e, msg);
        });

        _this27.registerEvent('focusin', name, function (e) {
          inputsOnFoucsIn(e, msg);
        });

        _this27.onLoad(function (form) {
          var formElem = _this27.getFormElem(form);

          formElem.on('submit', {
            name: name,
            formElem: formElem,
            msg: msg
          }, function (e) {
            inputsOnSubmit(e.data.name, e.data.formElem, e.data.msg);
          });
        });
      }); // lets to know if submit was triggered by 'ENTER'

      var onKeyPress = function onKeyPress(e) {
        var key = e.key;

        if (key.toUpperCase().trim() === 'ENTER') {
          _this27.keyEnterPressed = true;
          clearTimeout(_this27.pressOnEnterTimer);
          _this27.pressOnEnterTimer = setTimeout(function () {
            _this27.keyEnterPressed = false;
          }, 1000);
        }
      }; // lets to know if submit was triggered by click


      var clickOnSubmitFn = function clickOnSubmitFn(e) {
        _this27.submitBtnClicked = true;
        clearTimeout(_this27.clickOnSubmitTimer);
        _this27.clickOnSubmitTimer = setTimeout(function () {
          _this27.submitBtnClicked = false;
        }, 1000);
      };

      this.onLoad(function (form) {
        var formElem = _this27.getFormElem(form);

        if (formElem.length) {
          var submitBtn = formElem.find('button[type="submit"]');
          submitBtn.on('click', clickOnSubmitFn);
        }

        document.addEventListener('keypress', onKeyPress);
      }); // remove error message for empty focused input

      this.onValidate(function (_form) {
        setTimeout(function (_form) {
          var $form = _this27.getFormElem(_form);

          var fullNameElem = $form.find('[name="fullNameTrendemon"]');
          var focusedElem = $(document.activeElement);

          var showEmptyMsg = function showEmptyMsg(name) {
            return _this27.setErrorMessage(name, '  ', false);
          }; // show empty error message when focused field is empty


          if (focusedElem.length && _this27.keyEnterPressed) {
            var focusedElemTagName = focusedElem[0].tagName.toUpperCase();
            var val = focusedElem.val();
            var valIsEmty = !val.length;

            if (valIsEmty && (focusedElemTagName === 'INPUT' || focusedElemTagName === 'SELECT' || focusedElemTagName === 'TEXTAREA')) {
              var name = focusedElem.attr('name');

              if (args['validate_fullname']) {
                if (!fullNameElem.val()) {
                  showEmptyMsg(name);
                }
              } else {
                showEmptyMsg(name);
              }

              return;
            }
          } // set error state if submit is clicked and field is empty


          if (args['validate_fullname'] && _this27.submitBtnClicked && !_this27.keyEnterPressed) {
            var lastNameElem = $form.find('[name="LastName"]');

            if (!fullNameElem.val() || !lastNameElem.val()) {
              var parent = fullNameElem.parents('.mktoFieldWrap:first');
              fullNameElem.addClass('mktoInvalid');
              fullNameElem.removeClass('mktoValid');
              parent.addClass('mktoInvalidField'); // className "mktoFieldTouched" needed for red border on the input

              parent.addClass('mktoFieldTouched');

              _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
            }
          }

          _this27.submitBtnClicked = false;
          _this27.keyEnterPressed = false;
        }, 30, _form);
      });
      this.onLoad(function (form) {
        // set the input type on mktoFieldWrap element
        var formElem = _this27.getFormElem(form);

        if (typeof field_labels !== 'undefined') {
          $('label', formElem).each(function (i, elem) {
            var label = $(elem);

            if (typeof field_labels[label.text()] !== 'undefined') {
              label.text(field_labels[label.text()]);
            }
          });
        }

        $('input,textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = $(elem).attr('type');
          parent.addClass("inputType_".concat(inputType));

          if (typeof field_labels !== 'undefined') {
            var input = elem;

            if (typeof field_labels[input.getAttribute('placeholder')] !== 'undefined') {
              input.setAttribute('placeholder', field_labels[input.getAttribute('placeholder')]);
            }
          }
        });
        $('textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'textarea';
          parent.addClass("inputType_".concat(inputType));
        });
        $('select', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'select';
          parent.addClass("inputType_".concat(inputType));

          if ($(elem).attr('autoLables') !== 'false') {
            parent.find('.mktoLabel').text(parent.find('option:first').text());
          }

          parent.find('option:first').text('Please choose');
        });
        /* Potential use for translating buttons, however a brute (overall) solution was found for Downloads in /themes/impv-resources/loop-templates/content-gated-ungated.php
        $('button', formElem).each((i, elem) => {
          const button_text = $(elem).html();
          if (typeof field_labels !== 'undefined') {
            if (field_labels[button_text] !== 'undefined') {
              $(elem).html( field_labels[button_text] );
            }
          }
        }); */
      }) // populate the input validation and focuse state to the parent div
      .registerEvent('focus blur', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        /**
         * inputElem.is(document.activeElement) is workaround to support focus on safari
         */

        if (inputElem.is(':focus') || inputElem.is(document.activeElement)) {
          parent.addClass('mktoFieldFocus');
        } else {
          parent.removeClass('mktoFieldFocus');
        }

        setTimeout(function () {
          if (inputElem.hasClass('mktoInvalid')) {
            parent.addClass('mktoInvalidField');
          } else {
            parent.removeClass('mktoInvalidField');
          }
        }, 0);
      }) // populate the input validation to the parent div
      .registerEvent('focusin keyup', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');

        if (inputElem.hasClass('mktoInvalid')) {
          parent.addClass('mktoInvalidField');
        } else {
          parent.removeClass('mktoInvalidField');
        }
      }).registerEvent('focusout', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first'); // for the first time the imput was touched

        parent.addClass('mktoFieldTouched');
      }).registerEvent('change', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          parent.addClass('mktoFieldFill');
        } else {
          parent.removeClass('mktoFieldFill');
        }
      });
    }
  }, {
    key: "setHtmlTemplate",
    value: function setHtmlTemplate() {
      $(this.formElem).addClass('html-template');
    }
  }], [{
    key: "register",
    value: function register() {
      // find forms
      var formNodes = _toConsumableArray(document.querySelectorAll('form.marketo-form')); // create list with unique ids


      this.formIds = formNodes.reduce(function (list, form) {
        var id = form.dataset.formId;

        if (id && list.indexOf(id) === -1) {
          list.push(id);
        }

        return list;
      }, []); // init marketo forms for each ID

      this.formIds.forEach(function (formId) {
        // find forms with current id
        var idForms = _toConsumableArray(document.querySelectorAll("form.marketo-form[data-form-id=\"".concat(formId, "\"]"))); // next form with the same ID will be loaded on callback that takes MktoForms2.loadForm function


        (function loadFormHandler(idForms) {
          if (idForms.length) {
            var formEl = idForms.shift();
            var nextFormFn = loadFormHandler.bind(null, _toConsumableArray(idForms));
            var index = formNodes.indexOf(formEl);
            registerForm(index, formEl, nextFormFn);
          }
        })(idForms);
      });

      function registerForm(idx, e, runNextFormFn) {
        var formArgs = {};
        $(e).data('index', idx);

        try {
          var formArgsKey = $(e).data('form-args');

          if (formArgsKey && formArgsKey in window) {
            formArgs = window[formArgsKey];
          }
        } catch (err) {
          console.error('Faild to parse form args from element data', err);
        }

        var getFormId = function getFormId(e) {
          if (formArgs) {
            if (formArgs.form_id) {
              return formArgs.form_id;
            }
          }

          var formId = $(e).data('form-id');

          if (!formId) {
            var elId = $(e).attr('id');

            if (elId) {
              var s = elId.split('_');

              if (s.length > 1) {
                formId = s.pop();
              }
            }
          }

          return formId;
        };

        var formId = getFormId(e);
        console.info('register marketo form', formId);

        if (!formArgs.uuid) {
          formArgs.uuid = parseInt(Math.random() * 10000);
        }

        if (formId) {
          var uuid = formArgs.uuid;
          $(e).attr('data-uuid', uuid); // if someone waiting to this form - fire event

          var instance = new MarketoForm(formId, formArgs, e, runNextFormFn);

          if (typeof marketoForms[formId] === 'function') {
            var cb = marketoForms[formId];
            marketoForms[uuid] = instance;
            cb(instance);
          } else {
            marketoForms[uuid] = instance;
          }
        }
      }
    }
  }, {
    key: "findById",
    value: function findById(formId) {
      return new Promise(function (resolve) {
        var found = Object.values(marketoForms).filter(function (m) {
          return m.formId == formId;
        });

        if (found && found.length > 0) {
          resolve(found[0]);
        } else {
          marketoForms[formId] = resolve;
        }
      });
    }
  }]);

  return MarketoForm;
}();

exports["default"] = MarketoForm;

var createForm = function createForm(formId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var elem = arguments.length > 2 ? arguments[2] : undefined;
  return new MarketoForm(formId, args, elem);
};

exports.createForm = createForm;

var findById = function findById(formId) {
  return MarketoForm.findById(formId);
};

exports.findById = findById;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"impv/src/js/services/geo-location-service":14,"impv/src/js/services/translate-service":17}],11:[function(require,module,exports){
"use strict";

var _player = _interopRequireDefault(require("@vimeo/player"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

document.addEventListener('DOMContentLoaded', function () {
  var videoModals = document.querySelectorAll('.video-modal');
  var collection = new Map();

  var onShownModal = function onShownModal(e) {
    var iframe = e.data.iframe;
    var id = this.id;
    var player = collection.get(id);

    if (player && $(iframe).hasClass('autoplay')) {
      player.play();
    }
  };

  var onHideModal = function onHideModal(e) {
    var id = this.id;
    var player = collection.get(id);

    if (player) {
      player.pause();
    }
  };

  _toConsumableArray(videoModals).forEach(function (modal) {
    var iframe = modal.querySelector('iframe');
    var modalId = modal.id;
    var $modal = jQuery(modal);

    if (iframe) {
      var url = iframe.getAttribute('vidurl') || iframe.getAttribute('src');

      if (url.indexOf('vimeo') > -1) {
        iframe.setAttribute('src', url);
        collection.set(modalId, new _player["default"](iframe));
        $modal.on('shown.bs.modal', {
          iframe: iframe
        }, onShownModal);
        $modal.on('hide.bs.modal', onHideModal);
      }
    }
  });
});

},{"@vimeo/player":1}],12:[function(require,module,exports){
"use strict";

$(function () {
  if (window.hideYTActivated) return;
  var onYouTubeIframeAPIReadyCallbacks = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var playerWrap = _step.value;
      var playerFrame = playerWrap.querySelector('iframe');
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      var onPlayerStateChange = function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
          playerWrap.classList.add('ended');
        } else if (event.data == YT.PlayerState.PAUSED) {
          playerWrap.classList.add('paused');
        } else if (event.data == YT.PlayerState.PLAYING) {
          playerWrap.classList.remove('ended');
          playerWrap.classList.remove('paused');
        }
      };

      var player = void 0;
      onYouTubeIframeAPIReadyCallbacks.push(function () {
        player = new YT.Player(playerFrame, {
          events: {
            onStateChange: onPlayerStateChange
          }
        });
      });
      playerWrap.addEventListener('click', function (e) {
        if (e.target.className === 'close') {
          return;
        }

        var playerState = player.getPlayerState();

        if (playerState == YT.PlayerState.ENDED) {
          player.seekTo(0);
        } else if (playerState == YT.PlayerState.PAUSED) {
          player.playVideo();
        }
      });
    };

    for (var _iterator = document.querySelectorAll('.hytPlayerWrap')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  window.onYouTubeIframeAPIReady = function () {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = onYouTubeIframeAPIReadyCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var callback = _step2.value;
        callback();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  };

  window.hideYTActivated = true;
});
$(function () {
  $('.video-modal').each(function () {
    var $video = $(this).find('iframe');
    var videoSrc = $video.attr('vidurl') || $video.attr('src');
    var srcForYoutube = videoSrc + '?enablejsapi=1&rel=0';

    if (videoSrc.indexOf('vimeo') === -1) {
      $video.attr('src', srcForYoutube);
    }
  });
  $('.video-modal').on('hidden.bs.modal shown.bs.modal', function (e) {
    var videoFunc = e.type === 'shown' ? 'playVideo' : 'stopVideo';
    $(e.target).find('iframe')[0].contentWindow.postMessage("{\"event\":\"command\",\"func\":\"".concat(videoFunc, "\",\"args\":\"\"}"), '*');
  });
});

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GOOGLE_GEOCODE_CLIENT_API_KEY = window.pageGlobalData.GOOGLE_GEOCODE_CLIENT_API_KEY;
var _default = {
  API_KEY: GOOGLE_GEOCODE_CLIENT_API_KEY,
  BASE_URL: 'https://www.googleapis.com/geolocation/v1/geolocate'
};
exports["default"] = _default;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ERROR_STATUS = exports.FINISH_STATUS = exports.IN_PROGRESS_STATUS = exports.INITIAL_STATUS = exports.getGeoLocationData = exports.GeoLocationService = void 0;

var _googleGeolocationApi = _interopRequireDefault(require("../services/google-geolocation-api"));

var _sessionStorageService = _interopRequireDefault(require("./session-storage-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// create a uniqe symble
var singleton = Symbol();
/**
 *
 * This class is service to user data (country etc.)
 *
 * @example
 * import {getGeoLocationData} from './services/geo-location-service'
 * getGeoLocationData().then((data) => {
 *  // do something...
 * })
 *
 */

var GeoLocationService =
/*#__PURE__*/
function () {
  _createClass(GeoLocationService, null, [{
    key: "instance",

    /** process status */

    /** const keys */

    /**
     * @default GEO_LOCATION_DATA
     */

    /**
     * @default GEO_LOCTION_FINISHED
     */
    // return a singleton instance
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GeoLocationService();
      }

      return this[singleton];
    }
  }]);

  function GeoLocationService() {
    _classCallCheck(this, GeoLocationService);

    this.sessionStorageService = _sessionStorageService["default"];
    this.googleGeolocationAPI = _googleGeolocationApi["default"];
    this.baseURL = '/wp-json/geoLocationData/v1/geo';
    this.state = {
      status: GeoLocationService.INITIAL
    };
    this.init();
  }

  _createClass(GeoLocationService, [{
    key: "setState",
    value: function setState(newState) {
      var state = this.state;
      this.state = _objectSpread({}, state, {}, newState);

      if (this.state.status == GeoLocationService.ERROR) {
        console.error('GeoLocationService: An error occurred while trying to get user country', this.state.error);
        this.fireEvent(this.state);
      } else if (this.state.status == GeoLocationService.FINISH) {
        var _this$state = this.state,
            country = _this$state.country,
            countryCode = _this$state.countryCode,
            _state = _this$state.state,
            stateCode = _this$state.stateCode,
            city = _this$state.city,
            postalcode = _this$state.postalcode;
        this.sessionStorageService.setItem(GeoLocationService.CACHE_KEY, {
          country: country,
          countryCode: countryCode,
          state: _state,
          stateCode: stateCode,
          city: city,
          postalcode: postalcode
        });
        this.onFinish();
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
    /**
     *
     * @description register the user data loaded
     * this event will fire after all the process finished
     *
     * @example import {getGeoLocationData} from './services/geo-location-service';
     *  getGeoLocationData.then((data) => console.log('user data', data));
     *  or:
     *  $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, (data) => console.log('user data', data));
     * @return {Promise<object>}
     * return Promise object
     */

  }, {
    key: "fireEvent",
    value: function fireEvent(data) {
      $(document).trigger(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, data);
    }
  }, {
    key: "onFinish",
    value: function onFinish() {
      this.fireEvent(this.state);
    }
    /**
     *
     * get the user data from incapsula service
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserData",
    value: function getUserData() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // console.log(`GET ${this.baseURL}`);
        $.get(_this.baseURL).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            }
          }

          return reject('No data recived');
        }, function (err) {
          reject(err);
        });
      });
    }
    /**
     * getUserDataUsingLocation:
     *
     * get the user data from google geocodding service
     *
     * @param {{lat: string, lan: string}} latlng
     *  lan and lat location
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserDataUsingLocation",
    value: function getUserDataUsingLocation(latlng) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // console.log(`POST ${this.baseURL}`, latlng);
        $.post(_this2.baseURL, latlng).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            } else {
              return reject('No data provided, no country name was return');
            }
          } else {
            return reject('No data provided, failed');
          }
        }, function (err) {
          reject('request to server failed ' + err);
        });
      });
    }
  }, {
    key: "getLatLan",
    value: function getLatLan() {
      return this.googleGeolocationAPI.getLatLan();
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      this.setState({
        status: GeoLocationService.IN_PROGRESS
      }); // if the data already in cache return from cache

      var data = this.sessionStorageService.getItem(GeoLocationService.CACHE_KEY); // if the data found in cache return this data;

      if (data) {
        this.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
        return;
      } // else, start request the user data from the server
      // tring to get the user country name from incapsula service


      this.getUserData().then(function (data) {
        /**
         * if got the data finish the process and save the data to state and fire finish event
         */
        _this3.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
      }, // else; try another way:
      function (err) {
        // get the lan and lat location from google service
        _this3.getLatLan().then(function (latlng) {
          // parse the lan lat location to country name unsing google geocoding service
          _this3.getUserDataUsingLocation(latlng).then(function (data) {
            // if got the data finish the process and save the data to state and fire finish event
            _this3.setState(_objectSpread({
              status: GeoLocationService.FINISH
            }, data));
          }, function (err) {
            // console.error('Faild to get user data with latlan', err);
            _this3.setState({
              status: GeoLocationService.ERROR,
              error: err
            });
          });
        }, function (err) {
          // console.error('Faild to get user data', err);
          _this3.setState({
            status: GeoLocationService.ERROR,
            error: err
          });
        });
      });
    }
  }], [{
    key: "getGeoLocationData",
    value: function getGeoLocationData() {
      var instance = GeoLocationService.instance;
      return new Promise(function (resolve, reject) {
        if (instance.getState().status == GeoLocationService.FINISH) {
          resolve(instance.getState());
        } else {
          var cbFn = function cbFn(_, data) {
            reject(data.error);
            $(document).off(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
          };

          reject('No country data found');
          $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
        }
      });
    }
  }]);

  return GeoLocationService;
}();

exports.GeoLocationService = GeoLocationService;

_defineProperty(GeoLocationService, "INITIAL", 'INITIAL');

_defineProperty(GeoLocationService, "IN_PROGRESS", 'IN_PROGRESS');

_defineProperty(GeoLocationService, "FINISH", 'FINISH');

_defineProperty(GeoLocationService, "ERROR", 'ERROR');

_defineProperty(GeoLocationService, "CACHE_KEY", 'GEO_LOCATION_DATA');

_defineProperty(GeoLocationService, "GEO_LOCTION_FINISHED_EVENT", 'GEO_LOCTION_FINISHED');

var getGeoLocationData = GeoLocationService.getGeoLocationData;
exports.getGeoLocationData = getGeoLocationData;
var INITIAL_STATUS = GeoLocationService.INITIAL;
exports.INITIAL_STATUS = INITIAL_STATUS;
var IN_PROGRESS_STATUS = GeoLocationService.IN_PROGRESS;
exports.IN_PROGRESS_STATUS = IN_PROGRESS_STATUS;
var FINISH_STATUS = GeoLocationService.FINISH;
exports.FINISH_STATUS = FINISH_STATUS;
var ERROR_STATUS = GeoLocationService.ERROR;
exports.ERROR_STATUS = ERROR_STATUS;
var _default = GeoLocationService.instance;
exports["default"] = _default;

},{"../services/google-geolocation-api":15,"./session-storage-service":16}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _googleApi = _interopRequireDefault(require("../config/google-api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var API_KEY = _googleApi["default"].API_KEY,
    BASE_URL = _googleApi["default"].BASE_URL; // create a uniqe symble

var singleton = Symbol();

var GoogleGeolocationAPI =
/*#__PURE__*/
function () {
  function GoogleGeolocationAPI() {
    _classCallCheck(this, GoogleGeolocationAPI);
  }

  _createClass(GoogleGeolocationAPI, [{
    key: "createRequest",
    value: function createRequest(url) {
      return new Promise(function (resolve, reject) {
        $.post(url).done(resolve).fail(reject);
      });
    } // return a promise

  }, {
    key: "getLatLan",
    value: function getLatLan() {
      var url = "".concat(BASE_URL, "?key=").concat(API_KEY);
      return this.createRequest(url).then(function (res) {
        var _res$location = res.location,
            lat = _res$location.lat,
            lng = _res$location.lng; // convert lng to lan

        return {
          lat: lat,
          lan: lng
        };
      })["catch"](function (err) {
        return console.error('Faild to request lan - lat from google api');
      });
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GoogleGeolocationAPI();
      }

      return this[singleton];
    }
  }]);

  return GoogleGeolocationAPI;
}();

var _default = GoogleGeolocationAPI.instance;
exports["default"] = _default;

},{"../config/google-api":13}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isBrowserSupportSessionStorage = function isBrowserSupportSessionStorage() {
  return 'sessionStorage' in window;
}; // create a uniqe symble


var singleton = Symbol();

var SessionStorageService =
/*#__PURE__*/
function () {
  _createClass(SessionStorageService, null, [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new SessionStorageService();
      }

      return this[singleton];
    }
  }]);

  function SessionStorageService() {
    _classCallCheck(this, SessionStorageService);

    this.isSupported = isBrowserSupportSessionStorage();

    if (this.isSupported) {
      this.sessionStorage = window.sessionStorage;
    }
  }
  /**
   * load the value from sessionStorage
   * the value will parse to object using JSON.parse
   * @param {string} key
   * @param {object} value
   * @return {object}
   * TODO: implement expired date option, should return null if date is expired
   */


  _createClass(SessionStorageService, [{
    key: "getItem",
    value: function getItem(key) {
      try {
        if (!this.isSupported) return null;
        var value = this.sessionStorage.getItem(key);

        if (value) {
          return JSON.parse(value);
        } else {
          return null;
        }
      } catch (error) {
        console.log('An error occurred in SessionStorageService:getItem', error);
      }
    }
    /**
     * save the value in sessionStorage
     * the value will parse to string using JSON.stringify
     * @param {string} key
     * @param {object} value
     * @return {object}
     * TODO: implement expired date option,
     * should save the expired date as new item
     */

  }, {
    key: "setItem",
    value: function setItem(key, value) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log('An error occurred in SessionStorageService:setItem', error);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.removeItem(key);
      } catch (error) {
        console.log('An error occurred in SessionStorageService:removeItem', error);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.clear();
      } catch (error) {
        console.log('An error occurred in SessionStorageService:clear', error);
      }
    }
  }, {
    key: "generateKey",
    value: function generateKey(object) {
      var _this = this;

      if (!object) {
        return '';
      } else if (Array.isArray(object)) {
        return object.map(function (i) {
          return _this.generateKey(i);
        }).join('_');
      } else if (_typeof(object) === 'object') {
        return Object.keys(object).map(function (key) {
          return key + '_' + _this.generateKey(object[key]);
        }).join('_');
      }

      return object;
    }
  }]);

  return SessionStorageService;
}();

var _default = SessionStorageService.instance;
exports["default"] = _default;

},{}],17:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function byString(o, s) {
  try {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    s = s.replace(/^\./, ''); // strip a leading dot

    var a = s.split('.');

    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];

      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }

    return o;
  } catch (error) {
    return undefined;
  }
}

var TranslateService =
/*#__PURE__*/
function () {
  _createClass(TranslateService, null, [{
    key: "instance",
    get: function get() {
      if (!global.TranslateService) {
        global.TranslateService = new TranslateService();
      }

      return global.TranslateService;
    }
  }]);

  function TranslateService() {
    _classCallCheck(this, TranslateService);

    this.translate = this.translate.bind(this);
  }

  _createClass(TranslateService, [{
    key: "getTranlateMap",
    value: function getTranlateMap() {
      if (!this.tranlateMap) {
        this.tranlateMap = window.TranslateMap;
      }

      return this.tranlateMap;
    }
    /**
     * translate and field from Translate Option page on WP admin
     *
     * @param {string} field the field name (i.e. 'marketo_form.full_name_error_message')
     * @param {string | any} defaultValue if value is not exsist return this default value
     * @return {string} the translated text (or default value)
     *
     * @example
     *    import { translate } from 'impv/src/js/services/translate-service';
     *    translate('section.field_name', 'some_default_value_str');
     * 
     */

  }, {
    key: "translate",
    value: function translate() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tranlateMap = this.getTranlateMap();

      if (!field || !tranlateMap) {
        return defaultValue;
      } else {
        return byString(tranlateMap, field) || defaultValue;
      }
    }
  }]);

  return TranslateService;
}();

var _default = TranslateService.instance;
exports["default"] = _default;
var translate = TranslateService.instance.translate;
exports.translate = translate;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[5]);
